// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-28T20:49:33.210Z
// Property: Harborstone (ID: 6767906449166320)
// Collections: 27 amenities, 20 floorplans (live), 42 photos, 80 POIs, 5 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166320",
  "property_external_id": "30944",
  "property_zillow_url": "https://www.zillow.com/apartments/newport-news-va/harborstone/5Xr92c/",
  "property_apartments_url": "https://www.apartments.com/harborstone-newport-news-va/ke5rqgb/",
  "property_google_business_url": "https://www.google.com/maps/place/Harborstone+Apartment+Homes/data=!4m2!3m1!1s0x0:0x6ba76a10fc809d05?sa=X&ved=2ahUKEwjznavXpbiSAxWYmSYFHb1RKAQQ_BJ6BAhMEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "harborstone",
  "property_name": "Harborstone",
  "property_website_url": "https://www.liveharborstone.com/",
  "property_domain": "https://www.liveharborstone.com/",
  "property_address": "761 Adams Drive",
  "property_full_address": "761 Adams Dr, Newport News, VA 23601",
  "property_address_1": "761 Adams Dr",
  "property_address_2": null,
  "property_address_city": "Newport News",
  "property_address_state": "VA",
  "property_address_zip_full": "23601-2652",
  "property_address_zip": "23601",
  "property_address_country": "US",
  "property_address_county": "Newport News City",
  "property_neighborhood_address": "South Newport News",
  "property_address_latitude": "37.0582639",
  "property_address_longitude": "-76.4617313",
  "property_email": "harborstone@aionmanagement.com",
  "property_phone": "(757) 595-0201",
  "property_call_tracking_phone": "888-583-3031",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Harborstone in Newport News, VA, our vibrant community offers a diverse selection of floor plans, including cozy studios to spacious three-bedrooms. Enjoy top-notch amenities like a fully-equipped fitness center, resident lounge, and dog park, all designed for your comfort. Embrace a lifestyle where convenience meets community—make your move today!",
  "property_long_description": "Welcome to Harborstone, the ultimate in contemporary living located in the vibrant heart of Newport News, VA. Our thoughtfully designed apartment community offers a wide selection of floor plans to cater to your lifestyle, including stylish studios, cozy one-bedroom, spacious two-bedroom, and accommodating three-bedroom apartments. Every apartment is equipped with modern amenities and features that ensure comfort and convenience.\n\nAt Harborstone, we prioritize your well-being and leisure. Unwind in our welcoming clubhouse or enjoy outdoor gatherings at our grilling stations and picnic area. Stay active in our state-of-the-art fitness center, or take your furry friends to the on-site dog park. With resident activities, a playground for the little ones, and a resident lounge, there's always something happening in our community.\n\nWe understand the importance of convenience, which is why we offer a 24-hour emergency maintenance service, on-site management, and both on-site and off-street parking. Our online resident portal and flexible rent payment options make managing your home stress-free. Additionally, our controlled access building guarantees your safety and peace of mind.\n\nHarborstone is not just pet-friendly but also welcomes you with a variety of renovation options, including black appliances, upgraded bathroom tiles, and wall-to-wall carpeting. With high-speed internet available, you can effortlessly work or stream from home.\n\nReady to find your perfect home? Browse our availability today or schedule a tour to explore our vibrant community firsthand. Your ideal apartment awaits at Harborstone!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd912-301d-726d-8b53-8b12e3b6f3d0.webp",
  "property_featured_image_media": {
    "alt_text": "Modern white kitchen with stainless steel appliances and marble countertops.",
    "public_id": "019fd912-301d-726d-8b53-8b12e3b6f3d0",
    "storage_key": "property/6767906449166320/019fd912-301d-726d-8b53-8b12e3b6f3d0.webp",
    "width": 1666,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "296",
  "property_year_built": "1964",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.3108108108108",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "55",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $350, and monthly pet rent is $55",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://harborstonenewportnews.loftliving.com/login",
  "property_apply_now_url": "https://www.liveharborstone.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0268-2404-76ff-8c7d-8d60b758416c.webp",
  "property_primary_logo_media": {
    "alt_text": "Harborstone Newport News logo",
    "public_id": "019d0268-2404-76ff-8c7d-8d60b758416c",
    "storage_key": "property/6767906449166320/019d0268-2404-76ff-8c7d-8d60b758416c.webp",
    "width": 300,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0265-3942-77b3-83c7-038f46827caa.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0265-3942-77b3-83c7-038f46827caa",
    "storage_key": "property/6767906449166320/019d0265-3942-77b3-83c7-038f46827caa.webp",
    "width": 598,
    "height": 250
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0268-2ceb-7709-993e-469b3fa3f49a.webp",
  "property_icon_media": {
    "alt_text": "Homestead property management logo",
    "public_id": "019d0268-2ceb-7709-993e-469b3fa3f49a",
    "storage_key": "property/6767906449166320/019d0268-2ceb-7709-993e-469b3fa3f49a.webp",
    "width": 144,
    "height": 144
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0268-3775-77ca-a7b9-5d4e7f42175f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Harborstone - Newport News logo",
    "public_id": "019d0268-3775-77ca-a7b9-5d4e7f42175f",
    "storage_key": "property/6767906449166320/019d0268-3775-77ca-a7b9-5d4e7f42175f.webp",
    "width": 300,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0268-426b-771d-811c-2dfce71e2b51.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Harborstone Newport News logo",
    "public_id": "019d0268-426b-771d-811c-2dfce71e2b51",
    "storage_key": "property/6767906449166320/019d0268-426b-771d-811c-2dfce71e2b51.webp",
    "width": 300,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#706c6c",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "450 - 1050",
  "property_sqft_min": "450",
  "property_sqft_max": "1050",
  "property_price_range": "1754",
  "property_price_min": null,
  "property_price_max": "1754",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/Harborstoneapartments",
  "property_instagram_url": "https://www.instagram.com/harborstoneapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQRHBo8t5sIkRBZ2A_BBqp2s",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/pinedale-manor-newport-news",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Harborstone",
  "property_home_romance_title": "Embrace a Life You’ll Love in Our Charming Community",
  "property_home_amenities_blurb": "Welcome to Harborstone in Newport News, VA, where modern living meets comfort. Choose from stylish studio to spacious three-bedroom apartments, all designed with you in mind. Enjoy top-notch amenities, from a vibrant fitness center to cozy grilling stations and a pet-friendly dog park. Your perfect home awaits!",
  "property_home_floorplans_blurb": "Welcome to Harborstone, your serene retreat in Newport News, VA. Choose from a variety of thoughtfully designed floor plans, including cozy studios and spacious three-bedroom apartments. Each home offers unique charm and comfort—take a moment to browse our available apartments and find the perfect layout that suits your lifestyle!",
  "property_home_gallery_blurb": "At Harborstone in Newport News, VA, your ideal home awaits! Choose from studio to three-bedroom layouts, complemented by vibrant resident activities and a pet-friendly atmosphere. Enjoy modern amenities, a fitness center, and cozy lounging areas. Picture yourself thriving in a community that caters to your lifestyle.",
  "property_home_neighborhood_blurb": "At Harborstone in Newport News, VA, enjoy a vibrant community surrounded by access to premier educational institutions like Christopher Newport University and excellent parks like Riverview Farm Park. Embrace a lifestyle where culture meets convenience, with the Mariners' Museum nearby, inviting you to soak in local history and nature.",
  "property_home_reviews_blurb": "At Harborstone in Newport News, VA, our residents rave about the exceptional service they receive, especially from our star leasing agent, Caleb. As one resident shared, “Caleb made everything so much easier than I expected,” reflecting the warm, supportive community we pride ourselves on. Join us and thrive!",
  "property_neighborhood_blurb": "At Harborstone in Newport News, VA, your lifestyle is enhanced by an abundance of nearby amenities. With rich cultural spots like The Mariners' Museum and Virginia Living Museum, along with the tranquil expanses of Newport News Park, explore a world of entertainment and nature just steps from your new home. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Harborstone in Newport News, VA, where comfort meets convenience. Choose from a variety of floor plans, including studios and spacious three-bedrooms. Enjoy vibrant resident activities, a dog park, and a state-of-the-art fitness center. Experience refined living with our premium renovations and unbeatable amenities today!",
  "property_applynow_blurb": "At Harborstone in Newport News, VA, your dream home awaits! Choose from stylish studios to spacious three-bedroom floor plans, all enhanced by premium renovations. Enjoy a vibrant community with resident activities, a fitness center, and a pet-friendly dog park. Lease online today and embrace the lifestyle you've always wanted!",
  "property_contactus_blurb": "At Harborstone in Newport News, VA, we offer a range of stylish floor plans tailored to suit your lifestyle, from cozy studios to spacious three-bedroom apartments. Let our leasing team guide you in finding your perfect new home. Have questions? Contact us today for personalized assistance!",
  "property_faqs_blurb": "At Harborstone in Newport News, VA, our diverse range of floor plans—studio, one-bedroom, two-bedroom, and three-bedroom—offers the perfect blend of style and comfort. Curious about life here? Visit our FAQs page to get insights into our vibrant community and find answers to all your questions!",
  "property_floorplans_blurb": "At Harborstone in Newport News, VA, your ideal living space awaits. Choose from our stylish floor plans—ranging from cozy studios to spacious three-bedroom apartments. Each design harmoniously blends comfort and modernity. Ready to elevate your lifestyle? Browse our available apartment homes today and find the perfect fit for you!",
  "property_gallery_blurb": "At Harborstone in Newport News, VA, vibrant living meets modern convenience. Immerse yourself in stylish floor plans, from cozy studios to spacious three-bedroom apartments. Our community boasts exceptional amenities like a playful dog park, inviting clubhouse, and high-speed internet. Picture yourself here, where life feels effortlessly seamless!",
  "property_interactivemap_blurb": "Welcome to Harborstone in Newport News, VA, where modern living meets community charm. With versatile floor plans ranging from studios to three-bedroom homes, our pet-friendly amenities—including a fitness center, dog park, and resident lounge—create the perfect backdrop for your lifestyle. Use our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "At Harborstone in Newport News, VA, your furry friends are cherished as part of the family! With spacious apartments ready to accommodate up to two pets per home, you’ll find the perfect space for both you and your beloved companions. Embrace a living experience tailored for all lovers of paws and play!",
  "property_referafriend_blurb": "At Harborstone in Newport News, VA, we offer a variety of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Share the joy of community living—great friends make great neighbors! Invite a friend to experience our vibrant lifestyle today and enjoy all that Harborstone has to offer!",
  "property_residentaccess_blurb": "Welcome to Harborstone in Newport News, VA, where your comfort meets convenience. Choose from our diverse floor plans, including studio, one, two, and three-bedroom apartments. Enhance your experience—log in to the resident portal to effortlessly pay rent, schedule maintenance, and stay connected with community updates.",
  "property_reviews_blurb": "At Harborstone in Newport News, VA, our residents rave about the exceptional service provided by Caleb and the team. One resident said it best: “He made everything so much easier than I expected.” Experience dedicated support and a welcoming community today—see what our residents have to say about living here!",
  "property_created_at": "1757006097144",
  "property_scheduletour_blurb": "At Harborstone in Newport News, VA, a variety of thoughtfully designed floor plans await, from cozy studios to spacious three-bedroom apartments. Immerse yourself in a community that values comfort and connection. Schedule a tour today and hear firsthand from our residents about their vibrant living experience!",
  "property_thankyou_blurb": "Thank you for reaching out! At Harborstone in Newport News, VA, we offer a range of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Our team is excited to assist you on your journey to finding the perfect home. Stay tuned for our response!",
  "property_virtualtours_blurb": "At Harborstone in Newport News, VA, your ideal apartment awaits, from cozy studios to spacious three-bedroom layouts. Each floor plan is designed with comfort in mind. Ready to envision your new home? Take a virtual tour today and step inside our vibrant community!",
  "property_copyright": "2025 All Rights Reserved. Harborstone",
  "property_seo_title_home": "Apartments in Newport News, VA | Harborstone Living",
  "property_seo_description_home": "Discover 1, 2 & 3 bedroom apartments in Newport News, VA near I-64 and Newport News Shipyard with modern features and pet-friendly living.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments in Newport News, VA",
  "property_seo_description_floorplans": "Explore 1, 2 & 3 bedroom apartments in Newport News near Christopher Newport University, I-64, and major employers with spacious layouts.",
  "property_seo_title_amenities": "Amenities | Newport News, VA Apartments for Rent",
  "property_seo_description_amenities": "Enjoy fitness center, dog park, clubhouse, playground, and grilling areas at Newport News apartments near I-64 and Shipyard.",
  "property_seo_title_gallery": "Apartments in Newport News, VA | Photo Gallery",
  "property_seo_description_gallery": "View photos of apartments and community spaces in Newport News near Patrick Henry Mall, Shipyard, and local dining hotspots.",
  "property_seo_title_virtualtours": "Virtual Tours | Harborstone Apartments",
  "property_seo_description_virtualtours": "Experience Harborstone in Newport News, VA. Take a virtual tour of our stylish studio, one-, two-, and three-bedroom apartments ready to welcome you home!",
  "property_seo_title_interactivemap": "Interactive Map | Harborstone Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Harborstone in Newport News, VA! Use our interactive map to view floor plans, amenities, and start your journey to living well today!",
  "property_seo_title_neighborhood": "Apartments Near I-64 & Shipyard | Newport News, VA",
  "property_seo_description_neighborhood": "Live near Newport News Shipyard, Patrick Henry Mall, and I-64 with easy access to CNU, Fort Eustis, and Hampton Roads employers.",
  "property_seo_title_contact": "Contact Apartments in Newport News, VA | Harborstone",
  "property_seo_description_contact": "Contact Harborstone apartments in Newport News near I-64 and Shipyard. Learn more about our luxury 1, 2 & 3 bedroom homes today.",
  "property_seo_title_faqs": "FAQs | Apartments in Newport News, VA",
  "property_seo_description_faqs": "Get answers to your questions about Harborstone in Newport News, VA. Explore our community features, floor plans, and more. Your perfect home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Newport News, VA",
  "property_seo_description_reviews": "Join Harborstone in Newport News, VA! Experience vibrant living with top amenities and find your perfect apartment today!",
  "property_seo_title_applynow": "Apply for Apartments in Newport News, VA Near I-64",
  "property_seo_description_applynow": "Discover comfort and convenience at Harborstone, Newport News, VA. Enjoy diverse floor plans and pet-friendly amenities!",
  "property_seo_title_residentaccess": "Resident Access | Harborstone",
  "property_seo_description_residentaccess": "Log in to Harborstone’s resident portal for easy rent payments, maintenance requests, and community updates. Enjoy seamless living in Newport News!",
  "property_seo_title_referafriend": "Refer A Friend | Harborstone",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Harborstone in Newport News, VA, and enjoy a vibrant community together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Harborstone",
  "property_seo_description_scheduletour": "Schedule a tour of apartments in Newport News near Shipyard, CNU, and Fort Eustis. Visit our 1, 2 & 3 bedroom homes today.",
  "property_seo_title_privacy": "Privacy Policy | Harborstone",
  "property_seo_description_privacy": "Review the privacy policy for apartments in Newport News near Shipyard, CNU, and I-64. Learn how your information is protected.",
  "property_seo_title_accessibility": "Accessibility | Newport News Apartments Near I-64",
  "property_seo_description_accessibility": "Learn about accessibility at Newport News apartments near Shipyard, CNU, and I-64 with inclusive features for all residents.",
  "property_seo_title_sitemap": "Sitemap | Harborstone",
  "property_seo_description_sitemap": "Navigate your way through Harborstone in Newport News, VA! Check out our sitemap to find your ideal apartment and community features waiting for you.",
  "property_seo_title_thankyou": "Thank You | Harborstone",
  "property_seo_description_thankyou": "Thank you for reaching out to Harborstone in Newport News! Expect a warm welcome from our team soon as we help you find your perfect home.",
  "property_seo_title_pets": "Pet-Friendly Apartments in Newport News, VA",
  "property_seo_description_pets": "Find pet-friendly apartments in Newport News near parks, Shipyard, and Hampton Roads with dog park access and community amenities.",
  "property_updated_at": "1791293667749",
  "amenities": [
    {
      "id": "custom_e246aeec-66b3-43c3-8236-cf575e4c3475",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29d2a95d-6ecd-45e6-b9de-df40df6ecb6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba9b0347-d038-4479-b6b8-f170291cde27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d085d8c-1f51-46f1-9004-c8deb42433ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5538892f-84b5-4740-8c97-587cc6e3d6ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21ff932a-6c7b-43cc-841a-e82a1b41c80b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_621486da-e328-4231-9927-22de9f26023d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b216cea0-fa16-4790-95db-0639459bcfb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management Office",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3aae0589-9398-48bb-ac0a-408ff9c61ac9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_daadfe13-fba5-4560-9866-83ff7d7a0422",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21c1b92b-42e9-472d-811c-3857229b5a33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f049d8ed-ac87-4559-8d53-12b0f59931a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4ae2643-4396-4702-89f9-b59e8c98d692",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8e156b5-dc86-44ae-8e17-2a5985dffc52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af0b16a7-04c9-49b2-bf43-57d7359f9b1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc6b2d89-726e-42bd-81f2-28b98f743de7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a49e28dc-0538-4be3-9275-de660a680d13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_faf8d1b0-8119-410e-aed5-70618d277f23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5704dfc4-cc0e-478a-a816-145e04656c78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens & Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9323d59b-8561-4eaf-ac36-54aad6ac11b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ac31c57-d57d-46ac-a66d-c22c92b920f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5699c66e-976d-44ce-9ee5-7cc936e20f34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-to-Wall Carpet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d58abff9-f927-47d1-b63e-b3335c218cef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_142bcf5b-9487-4839-b9fe-621d4b658898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2aeaee9d-08ad-4a47-8a67-2bd101e3d9eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling and Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_327d3f13-64fc-405d-b6ab-2e92d538592f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af829f64-1306-4531-a8f9-0588eb317321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f20204d1-4350-4667-ad60-3979f1b7dcb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-81b1-709b-86f0-e17071ffd8c5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019fd922-81b1-709b-86f0-e17071ffd8c5",
        "storage_key": "property/6767906449166320/019fd922-81b1-709b-86f0-e17071ffd8c5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "White kitchen with white cabinets, marble-look countertops, and stainless steel appliances. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/5bbc707fa5bf0c84f2fc63565c5ace4a-38a07e65-1920w.png"
    },
    {
      "id": "custom_492c8625-ad55-41b0-a73d-4e004add1236",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-81f6-7429-8928-e371d6423304.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, dishwasher, sink, microwave, and stove in a white kitchen.",
        "public_id": "019fd922-81f6-7429-8928-e371d6423304",
        "storage_key": "property/6767906449166320/019fd922-81f6-7429-8928-e371d6423304.webp",
        "width": 1920,
        "height": 1260
      },
      "title": "Apartment",
      "description": "Bright, modern kitchen with white cabinetry, marble-like countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel fridge, stove, and sink. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/794c5af0c4cbf6f472e983bea8825f69-2183cf02-1920w.png"
    },
    {
      "id": "custom_028d7275-b22b-436e-a54c-d5b048eff9a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-8069-75e4-8f37-60fa1b9f3e23.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and television.",
        "public_id": "019fd922-8069-75e4-8f37-60fa1b9f3e23",
        "storage_key": "property/6767906449166320/019fd922-8069-75e4-8f37-60fa1b9f3e23.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-009_13-07-26_14_40-1920w.jpg"
    },
    {
      "id": "custom_a8b8c2fc-3430-4cbf-99cb-de5812f3633d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-8052-70ba-897b-8e46224a68a1.webp",
      "image_media": {
        "alt_text": "A dark gray sectional sofa with a plaid throw is placed in a living room with a sliding glass door and a decorative shelf.",
        "public_id": "019fd922-8052-70ba-897b-8e46224a68a1",
        "storage_key": "property/6767906449166320/019fd922-8052-70ba-897b-8e46224a68a1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy the comfort and style of this spacious living area, perfect for relaxing or entertaining. Features a large sofa, decorative shelving, and access to outdoor space.",
      "link": "",
      "alt_text": "A dark gray sectional sofa with a plaid throw is placed in a living room with a sliding glass door and a decorative shelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-004_13-07-26_15_08-1920w.jpg"
    },
    {
      "id": "custom_763b8836-734b-45c6-9741-292d9262ea4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-8d74-7539-bd63-e28e4b656e8a.webp",
      "image_media": {
        "alt_text": "Spacious living room with grey sofa, entertainment console, and large TV.",
        "public_id": "019fd922-8d74-7539-bd63-e28e4b656e8a",
        "storage_key": "property/6767906449166320/019fd922-8d74-7539-bd63-e28e4b656e8a.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed living room, featuring a plush grey sofa perfect for relaxation, a sleek entertainment console, and a large flat-screen TV, creating an inviting atmosphere for entertainment and comfort.",
      "link": "",
      "alt_text": "Spacious living room with grey sofa, entertainment console, and large TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-003_13-07-26_15_27-1920w.jpg"
    },
    {
      "id": "custom_09b05087-13b9-495f-ba23-10b49cbeafa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-8d9a-748f-af37-7861fb409cee.webp",
      "image_media": {
        "alt_text": "Interior hallway with a console table and artwork leading to a living room.",
        "public_id": "019fd922-8d9a-748f-af37-7861fb409cee",
        "storage_key": "property/6767906449166320/019fd922-8d9a-748f-af37-7861fb409cee.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Apartment",
      "description": "Welcome to your stylish apartment hallway, featuring a decorative console table and artwork, with a glimpse into the inviting living room.",
      "link": "",
      "alt_text": "Interior hallway with a console table and artwork leading to a living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-002_13-07-26_15_49-1920w.jpg"
    },
    {
      "id": "custom_c336198e-f025-4c1b-a28a-464bb4dcb5a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-9085-7647-ab78-5dfaf884cd4a.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a closet next to a kitchen counter and stainless steel refrigerator.",
        "public_id": "019fd922-9085-7647-ab78-5dfaf884cd4a",
        "storage_key": "property/6767906449166320/019fd922-9085-7647-ab78-5dfaf884cd4a.webp",
        "width": 1920,
        "height": 1248
      },
      "title": "Apartment",
      "description": "Bright apartment with a stacked washer/dryer in a closet, adjacent to white cabinets and a stainless steel refrigerator.",
      "link": "",
      "alt_text": "Stacked washer and dryer in a compact laundry closet beside white kitchen cabinets. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/c5e4d6e451d98cae7edabdfb124e2e05-7426565b-1920w.png"
    },
    {
      "id": "custom_4ab745bd-3543-45c0-b37d-a17b624ec38e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-907b-7747-b942-0cbb6e5bd211.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstands, dresser, and ceiling fan.",
        "public_id": "019fd922-907b-7747-b942-0cbb6e5bd211",
        "storage_key": "property/6767906449166320/019fd922-907b-7747-b942-0cbb6e5bd211.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Bedroom with a bed, nightstands, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-007_13-07-26_14_42-1920w.jpg"
    },
    {
      "id": "custom_f1a42153-98c0-49f7-abe4-65045c102c67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-97df-76aa-9eb3-e4a5d7bdfb30.webp",
      "image_media": {
        "alt_text": "Modern bedroom with queen bed, ceiling fan, and large window.",
        "public_id": "019fd922-97df-76aa-9eb3-e4a5d7bdfb30",
        "storage_key": "property/6767906449166320/019fd922-97df-76aa-9eb3-e4a5d7bdfb30.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Spacious and modern bedroom featuring a comfortable queen-size bed, a refreshing ceiling fan, and ample natural light from a large window.",
      "link": "",
      "alt_text": "Modern bedroom with queen bed, ceiling fan, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-010_13-07-26_14_32-1920w.jpg"
    },
    {
      "id": "custom_14b60aeb-d6aa-4346-b9e5-4380cdf15021",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-981b-766e-a255-605d10d6da5d.webp",
      "image_media": {
        "alt_text": "Bedroom with desk and chair, hallway view.",
        "public_id": "019fd922-981b-766e-a255-605d10d6da5d",
        "storage_key": "property/6767906449166320/019fd922-981b-766e-a255-605d10d6da5d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, a desk with a chair, and a view down a hallway.",
      "link": "",
      "alt_text": "Bedroom with desk and chair, hallway view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-005_13-07-26_14_45-1920w.jpg"
    },
    {
      "id": "custom_ba99b2ce-b4a3-4639-806b-73130f987e16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-9b35-7779-a632-e6856cf8a762.webp",
      "image_media": {
        "alt_text": "Balcony with seating overlooking apartment buildings and trees in autumn.",
        "public_id": "019fd922-9b35-7779-a632-e6856cf8a762",
        "storage_key": "property/6767906449166320/019fd922-9b35-7779-a632-e6856cf8a762.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Covered balcony with cushioned outdoor sofa and pillows, overlooking a green lawn and neighboring apartment buildings. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/6ae684ef85d0055a0d16f2a0e41ea300-36f00ea0-1920w.webp"
    },
    {
      "id": "custom_4f2be3d3-35ac-4f90-b070-f79722c879ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-9b58-73d9-a3c7-dabda404b112.webp",
      "image_media": {
        "alt_text": "Studio apartment living area with a daybed, desk, and view into the kitchen.",
        "public_id": "019fd922-9b58-73d9-a3c7-dabda404b112",
        "storage_key": "property/6767906449166320/019fd922-9b58-73d9-a3c7-dabda404b112.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "This studio apartment features a comfortable daybed, a functional workspace with a desk and laptop, and a seamless transition into the kitchen area. Perfect for modern living.",
      "link": "",
      "alt_text": "Studio apartment living area with a daybed, desk, and view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Property_2CB1_Harborstone-POI-012_13-07-26_15_05-1920w.jpg"
    },
    {
      "id": "custom_9609fc7a-8362-4feb-a91f-7c9e3dec226b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-a32a-710d-95cf-7711e49c91d4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fd922-a32a-710d-95cf-7711e49c91d4",
        "storage_key": "property/6767906449166320/019fd922-a32a-710d-95cf-7711e49c91d4.webp",
        "width": 1845,
        "height": 1230
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with black appliances, dark cabinetry, and light countertops.",
      "link": "",
      "alt_text": "Modern apartment kitchen with black appliances, dark cabinets, and light countertops. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/fa2fe49762673270e1da17198355f7ce-c2cb0b46-1920w.png"
    },
    {
      "id": "custom_18c88a4d-f6f1-4df4-9740-699a9bd91aea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-a212-72b2-b03f-16cd2a6929a8.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, granite countertops, stainless steel appliances, and a window.",
        "public_id": "019fd922-a212-72b2-b03f-16cd2a6929a8",
        "storage_key": "property/6767906449166320/019fd922-a212-72b2-b03f-16cd2a6929a8.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with dark cabinets, granite countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Kitchen in an apartment unit with dark wood cabinets, black appliances, and granite countertops. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/75c7fd3200a8e11c90cbda1245557a87-52dee326-1920w.webp"
    },
    {
      "id": "custom_68be9f7d-5e1c-402a-a774-ba75f42e7d08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-a6e6-74c3-8512-529f45f83ab9.webp",
      "image_media": {
        "alt_text": "Living room with a couch, armchair, coffee table, and TV.",
        "public_id": "019fd922-a6e6-74c3-8512-529f45f83ab9",
        "storage_key": "property/6767906449166320/019fd922-a6e6-74c3-8512-529f45f83ab9.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable couch, accent chair, coffee table, and entertainment center with a large television.",
      "link": "",
      "alt_text": "Living room in an apartment with beige sofa, coffee table, TV on a wooden console, plant. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/0bd279e1b87990b68838c17eb072cc47-5324c354-1920w.webp"
    },
    {
      "id": "custom_c1a75743-ae8d-491a-9d4a-60cbe5526e0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-a73d-707e-a3fb-e9bac2f6d4d9.webp",
      "image_media": {
        "alt_text": "Living room with beige sofa, coffee table, bookshelf, and sliding glass doors.",
        "public_id": "019fd922-a73d-707e-a3fb-e9bac2f6d4d9",
        "storage_key": "property/6767906449166320/019fd922-a73d-707e-a3fb-e9bac2f6d4d9.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Living room in an apartment with a beige sofa, wooden coffee table, and a tall bookshelf beside a sliding glass door. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/7b96be3773b86a0cedc4fdc9ae6112d2-769e40a6-1920w.jpg"
    },
    {
      "id": "custom_ed6e3bca-95f9-4ab9-bd35-be79a167135d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-acf8-7717-a748-ca7ecbcf446f.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, nightstand, and fan.",
        "public_id": "019fd922-acf8-7717-a748-ca7ecbcf446f",
        "storage_key": "property/6767906449166320/019fd922-acf8-7717-a748-ca7ecbcf446f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, neutrally decorated apartment bedroom with a bed, dresser, two nightstands, and a ceiling fan.",
      "link": "",
      "alt_text": "Furnished bedroom in an apartment with a bed, two nightstands, dresser, and ceiling fan. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/95f802d7dfd2aa897ecc4fe5741a7598-00d55abe-1920w.jpg"
    },
    {
      "id": "custom_810542a4-c5be-41b6-bc62-ae2d10f99629",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-aea6-73bf-bfb0-4bcfe2b374ae.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with white refrigerator and wooden cabinets.",
        "public_id": "019fd922-aea6-73bf-bfb0-4bcfe2b374ae",
        "storage_key": "property/6767906449166320/019fd922-aea6-73bf-bfb0-4bcfe2b374ae.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with wooden cabinets, white appliances, and a round dining table.",
      "link": "",
      "alt_text": "Apartment kitchen with wooden cabinets, white appliances, and a round dining table. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/0fe0a7c2cc15836e82c5a530f20f4410-24076df2-1920w.webp"
    },
    {
      "id": "custom_ccb45abe-a5b1-4f8d-9ebd-67fcc7db1e24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-b194-77fc-bd10-577eb16e306c.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and chairs adjacent to a kitchen.",
        "public_id": "019fd922-b194-77fc-bd10-577eb16e306c",
        "storage_key": "property/6767906449166320/019fd922-b194-77fc-bd10-577eb16e306c.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright living area in a multifamily unit with neutral furnishings and an open kitchen.",
      "link": "",
      "alt_text": "Living room interior with a gray sofa, two chairs, and a coffee table; open kitchen in background. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/5520c694d9f149065d4431dc4eeb26d4-a071938b-1920w.webp"
    },
    {
      "id": "custom_3eaeb377-afc5-4a76-bc04-53d079ed9a63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-b27e-7748-ab21-8ca512e96704.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, black faucet, toilet, and a shower/tub.",
        "public_id": "019fd922-b27e-7748-ab21-8ca512e96704",
        "storage_key": "property/6767906449166320/019fd922-b27e-7748-ab21-8ca512e96704.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Clean and modern bathroom featuring a spacious vanity, a sleek black faucet, and a convenient shower/tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, black faucet, toilet, and a shower/tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-006-1920w.jpg"
    },
    {
      "id": "custom_a55c240f-39b4-4f64-9765-d010fc5b9101",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-b771-761d-b8f8-e3b48373e414.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, bathtub, vanity with sink, and mirror.",
        "public_id": "019fd922-b771-761d-b8f8-e3b48373e414",
        "storage_key": "property/6767906449166320/019fd922-b771-761d-b8f8-e3b48373e414.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Apartment",
      "description": "Clean and modern bathroom featuring a toilet, bathtub with shower, a vanity with a sink and ample counter space, and a well-lit mirror.",
      "link": "",
      "alt_text": "Bathroom with a toilet, bathtub, vanity with sink, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-011-1920w.jpg"
    },
    {
      "id": "custom_66c35904-54f5-44f3-ac93-3f554dce430e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-bb39-7009-97d1-0b5545dff7b2.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink.",
        "public_id": "019fd922-bb39-7009-97d1-0b5545dff7b2",
        "storage_key": "property/6767906449166320/019fd922-bb39-7009-97d1-0b5545dff7b2.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a tub/shower, toilet, and vanity.",
      "link": "",
      "alt_text": "Bathroom with white tub/shower, toilet, and sink with a mirror. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/919eef28e4ba9ba9eb82e2fa416e5d49-64a68a70-1920w.webp"
    },
    {
      "id": "custom_13d47f44-198a-4556-8875-a50727e43a4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-4c08-73a5-8dc4-9f37c7400923.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with carpet, vertical blinds on sliding glass door, and a closed white door.",
        "public_id": "01a18441-4c08-73a5-8dc4-9f37c7400923",
        "storage_key": "property/6767906449166320/01a18441-4c08-73a5-8dc4-9f37c7400923.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and carpeted living area with a sliding glass door leading to a private balcony or patio, perfect for relaxation.",
      "link": "",
      "alt_text": "Empty apartment living room with carpet, vertical blinds on sliding glass door, and a closed white door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c362a0b-8406-44df-bfc0-eb27515aace8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-37ca-7029-b0bc-7c98d10d4b80.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass doors leading to a balcony and a closed door on the right.",
        "public_id": "01a18441-37ca-7029-b0bc-7c98d10d4b80",
        "storage_key": "property/6767906449166320/01a18441-37ca-7029-b0bc-7c98d10d4b80.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious living area with modern wood-look flooring and a sliding glass door that opens to a private balcony.",
      "link": "",
      "alt_text": "Empty living room with sliding glass doors leading to a balcony and a closed door on the right.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c72d80f1-c0b9-4b0f-977a-5e532715be02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-38e5-75f0-973d-ec9d47995f1b.webp",
      "image_media": {
        "alt_text": "Empty living room with gray walls and wood-look flooring.",
        "public_id": "01a18441-38e5-75f0-973d-ec9d47995f1b",
        "storage_key": "property/6767906449166320/01a18441-38e5-75f0-973d-ec9d47995f1b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and bright empty living room featuring modern gray walls and stylish wood-look flooring, perfect for personalization.",
      "link": "",
      "alt_text": "Empty living room with gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f36f1b96-de39-45ca-83c1-2ee570d911cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-4e61-764c-bfa5-212d4caa44c9.webp",
      "image_media": {
        "alt_text": "Living room with stackable washer and dryer and sliding glass door leading to a wooden deck.",
        "public_id": "01a18441-4e61-764c-bfa5-212d4caa44c9",
        "storage_key": "property/6767906449166320/01a18441-4e61-764c-bfa5-212d4caa44c9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a stackable washer and dryer and a sliding glass door that opens to a private deck, perfect for enjoying the outdoors.",
      "link": "",
      "alt_text": "Living room with stackable washer and dryer and sliding glass door leading to a wooden deck.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e27bcee1-4452-46eb-9585-57765d54b755",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-63f1-710f-b87d-aeebc329a2fc.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with grey walls, wood-look floors, and a closet.",
        "public_id": "01a18441-63f1-710f-b87d-aeebc329a2fc",
        "storage_key": "property/6767906449166320/01a18441-63f1-710f-b87d-aeebc329a2fc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment living area featuring modern grey walls and wood-style flooring. Ample closet space available for your storage needs.",
      "link": "",
      "alt_text": "Empty apartment living room with grey walls, wood-look floors, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abe920d9-e326-4807-a7e4-a63adc356f82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-65ab-76df-9fe0-560ad9a764a0.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and a window.",
        "public_id": "01a18441-65ab-76df-9fe0-560ad9a764a0",
        "storage_key": "property/6767906449166320/01a18441-65ab-76df-9fe0-560ad9a764a0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious and bright bedroom featuring a ceiling fan and ample natural light from a large window. Perfect for your personal sanctuary.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0bbdd8b1-1c39-4332-9277-6abe0c3dc79a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-3b23-7327-a02a-7b7e48f06995.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with carpet, ceiling fan, and blinds on windows.",
        "public_id": "01a18441-3b23-7327-a02a-7b7e48f06995",
        "storage_key": "property/6767906449166320/01a18441-3b23-7327-a02a-7b7e48f06995.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort in this spacious bedroom, complete with plush carpeting, a modern ceiling fan, and large windows that let in plenty of natural light.",
      "link": "",
      "alt_text": "Spacious bedroom with carpet, ceiling fan, and blinds on windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70453960-fdad-4564-8d7b-42f066f5c0b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-3835-7708-a783-914e53536ac8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with gray walls, carpet, a window with blinds, and a white door.",
        "public_id": "01a18441-3835-7708-a783-914e53536ac8",
        "storage_key": "property/6767906449166320/01a18441-3835-7708-a783-914e53536ac8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and neutral bedroom featuring plush carpeting, a large window with blinds for natural light, and a classic white interior door. Perfect for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with gray walls, carpet, a window with blinds, and a white door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9599fcb-7e32-485e-b9e9-47cb94e063c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a18441-39fa-77e9-9dc8-ee42341477e2.webp",
      "image_media": {
        "alt_text": "Interior view of a bedroom with a ceiling fan and a closet door.",
        "public_id": "01a18441-39fa-77e9-9dc8-ee42341477e2",
        "storage_key": "property/6767906449166320/01a18441-39fa-77e9-9dc8-ee42341477e2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This inviting bedroom features plush carpeting, a ceiling fan for comfort, and ample closet space.",
      "link": "",
      "alt_text": "Interior view of a bedroom with a ceiling fan and a closet door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_758d2ff5-4baf-4edf-803b-b2a6beeb6363",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-bf4b-70db-a786-9d9d2f6605ff.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight rack, and benches.",
        "public_id": "019fd922-bf4b-70db-a786-9d9d2f6605ff",
        "storage_key": "property/6767906449166320/019fd922-bf4b-70db-a786-9d9d2f6605ff.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, weight rack, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-014-1920w.jpg"
    },
    {
      "id": "custom_571d4d90-aa28-4c5c-aadc-94fd62419ec5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-c136-72aa-80be-1e5aa45298ee.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with comfortable seating and a wet bar.",
        "public_id": "019fd922-c136-72aa-80be-1e5aa45298ee",
        "storage_key": "property/6767906449166320/019fd922-c136-72aa-80be-1e5aa45298ee.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal lounge, featuring comfortable seating and a convenient wet bar for resident use.",
      "link": "",
      "alt_text": "Modern communal lounge area with comfortable seating and a wet bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-013-1920w.jpg"
    },
    {
      "id": "custom_2aec3a5f-5750-4fb4-849a-563549ca13b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-ca7f-7428-8ff7-70b3e3372ddd.webp",
      "image_media": {
        "alt_text": "Community lounge area with high-top table and stools, seating area, and view into fitness center.",
        "public_id": "019fd922-ca7f-7428-8ff7-70b3e3372ddd",
        "storage_key": "property/6767906449166320/019fd922-ca7f-7428-8ff7-70b3e3372ddd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Resident Lounge",
      "link": "",
      "alt_text": "A modern lounge with a long white table, yellow chairs, a grey sofa, and a wall-mounted TV in a light-colored room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/DSCF3242_3_4_5_6+copy-1920w.jpg"
    },
    {
      "id": "custom_2a126ba7-96be-4763-b0a9-0ef2d69a52f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-cdd3-72a4-8195-29f42bed7723.webp",
      "image_media": {
        "alt_text": "Playground equipment with slides and a bench.",
        "public_id": "019fd922-cdd3-72a4-8195-29f42bed7723",
        "storage_key": "property/6767906449166320/019fd922-cdd3-72a4-8195-29f42bed7723.webp",
        "width": 1732,
        "height": 1181
      },
      "title": "Community",
      "description": "Outdoor community playground with orange slides and climbing features set in a shaded, green space for residents.",
      "link": "",
      "alt_text": "Bright orange playground structure with slides in a fenced, tree-filled area. Enjoy a variety of onsite community amenities at Harborstone Apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/c1d34079a23a01803ea30028e2a29463-be4fe5d1-9764ba72-1920w.png"
    },
    {
      "id": "custom_6608ae34-5df1-4791-9d2e-895efee03d1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-ccdf-720e-ba9c-221b04c75bb0.webp",
      "image_media": {
        "alt_text": "Outdoor picnic pavilion with grills and a playground in the background.",
        "public_id": "019fd922-ccdf-720e-ba9c-221b04c75bb0",
        "storage_key": "property/6767906449166320/019fd922-ccdf-720e-ba9c-221b04c75bb0.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our picnic pavilion, complete with grills and a nearby playground for family fun.",
      "link": "",
      "alt_text": "Outdoor picnic pavilion with grills and a playground in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-020-1920w.jpg"
    },
    {
      "id": "custom_dd721514-6240-4048-bc85-4a9e486957be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-d5be-7182-b87d-27a9d6d72608.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, picnic tables, and a gazebo.",
        "public_id": "019fd922-d5be-7182-b87d-27a9d6d72608",
        "storage_key": "property/6767906449166320/019fd922-d5be-7182-b87d-27a9d6d72608.webp",
        "width": 1920,
        "height": 1254
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Fenced dog park with a sign, gazebo, and playground beyond, bordered by trees. Enjoy a pet-friendly community at Harborstone Apartments in Newport News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/640dd92e80936b8ac3a19ff90b27c1d0-17d0e955-1920w.png"
    },
    {
      "id": "custom_32efcb78-48a1-446b-8204-b6ef8891e302",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-d8cc-74e6-aaa6-6203a2d4159d.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with a well-maintained lawn and flower beds.",
        "public_id": "019fd922-d8cc-74e6-aaa6-6203a2d4159d",
        "storage_key": "property/6767906449166320/019fd922-d8cc-74e6-aaa6-6203a2d4159d.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Community",
      "description": "Charming brick apartment building with a welcoming entrance and beautifully landscaped grounds, offering a pleasant living environment.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with a well-maintained lawn and flower beds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-017-1920w.jpg"
    },
    {
      "id": "custom_4a5ebb0c-d9b5-44a5-9728-60bb32f156b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-db62-70b4-a461-612969f7e542.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment buildings with yellow doors and balconies, parking lot and green lawn.",
        "public_id": "019fd922-db62-70b4-a461-612969f7e542",
        "storage_key": "property/6767906449166320/019fd922-db62-70b4-a461-612969f7e542.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring brick exteriors, bright yellow doors, and balconies. The property includes a parking area and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior of brick apartment buildings with yellow doors and balconies, parking lot and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-015-1920w.jpg"
    },
    {
      "id": "custom_e1e7a330-235d-447f-960c-f3bbe2a3e299",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-e38f-7747-a4b1-52951c857b44.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with a parking lot and manicured landscaping.",
        "public_id": "019fd922-e38f-7747-a4b1-52951c857b44",
        "storage_key": "property/6767906449166320/019fd922-e38f-7747-a4b1-52951c857b44.webp",
        "width": 1920,
        "height": 1253
      },
      "title": "Community",
      "description": "Exterior view of a brick-architecture apartment community with parking, landscaping, and balconies.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with a parking lot and trees. Welcome home to Harborstone Apartments, offering studio, 1, and 2-bedroom apartments for rent in New Port News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/77be03906f8e06ea49b36fa882848338-7f389881-1920w.png"
    },
    {
      "id": "custom_6e20393b-85e0-4f51-85cd-45ffd8a861cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-e5e3-761e-8b8e-ad132c8c7cef.webp",
      "image_media": {
        "alt_text": "Harborstone Newport News monument sign with manicured landscaping",
        "public_id": "019fd922-e5e3-761e-8b8e-ad132c8c7cef",
        "storage_key": "property/6767906449166320/019fd922-e5e3-761e-8b8e-ad132c8c7cef.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Harborstone Newport News monument sign with manicured landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/Harborstone-POI-016-1920w.jpg"
    },
    {
      "id": "custom_9ce7fd66-cd22-466d-81fb-53ae7ef591d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-e846-76de-8ca7-efc9a423e564.webp",
      "image_media": {
        "alt_text": "Aerial view of brick apartment buildings surrounded by lush green trees under a cloudy sky.",
        "public_id": "019fd922-e846-76de-8ca7-efc9a423e564",
        "storage_key": "property/6767906449166320/019fd922-e846-76de-8ca7-efc9a423e564.webp",
        "width": 1920,
        "height": 1232
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Aerial view of brick apartment buildings among trees with a parking lot. Welcome home to Harborstone Apartments, offering studio, 1, and 2-bedroom apartments for rent in New Port News, VA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/f80b3b82/dms3rep/multi/opt/fb529aa68e3bf4271787c80fd9a0a5a0-52dfe179-1920w.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e4e441b2-86b0-421f-bbf2-937be3a26626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Indulge Bakery & Bistro",
      "poi_type": "Restaurants",
      "poi_address": "10359 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Casual, family-run eatery (bistro-style) specializing in breakfast classics, sandwiches and coffee drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd920-f9c0-72cd-9d8a-445310a3b5ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-f9c0-72cd-9d8a-445310a3b5ea",
        "storage_key": "property/6767906449166320/019fd920-f9c0-72cd-9d8a-445310a3b5ea.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.indulgebakeryandbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16960482132347508209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indulge-bakery--bistro",
      "poi_latitude": "37.0328612",
      "poi_longitude": "-76.4619503",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-594-1399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJke8ifQF4sIkR8dXujaO8X-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2115595c-1e2f-4e5c-9ab4-60bb1539aa1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Spuntini Bakery",
      "poi_type": "Restaurants",
      "poi_address": "10373 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Casual bakery, cafe and espresso bar using organic ingredients, plus gluten-free options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-0691-71cf-abca-31d0e11c1942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-0691-71cf-abca-31d0e11c1942",
        "storage_key": "property/6767906449166320/019fd921-0691-71cf-abca-31d0e11c1942.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://spuntinibakeryva.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=10686323696659126631",
      "poi_directions_map_url": "https://maps.google.com/?cid=2092965142200052577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spuntini-bakery",
      "poi_latitude": "37.0330708",
      "poi_longitude": "-76.4623281",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-232-1844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTkCsTV5sIkRYesbNLW0Cx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9d2532cc-3fea-4a82-a568-cd995324111e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Circa 1918 Kitchen and Bar",
      "poi_type": "Restaurants",
      "poi_address": "10367 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Intimate, romantic restaurant furnishing New American bites & an extensive wine list.",
      "poi_long_description": "Intimate, romantic restaurant furnishing New American bites & an extensive wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-0924-743d-966b-f0403eab133d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-0924-743d-966b-f0403eab133d",
        "storage_key": "property/6767906449166320/019fd921-0924-743d-966b-f0403eab133d.webp",
        "width": 1280,
        "height": 995
      },
      "poi_business_url": "http://www.circa1918kitchenandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15386898629809256691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circa-1918-kitchen-and-bar",
      "poi_latitude": "37.0330389",
      "poi_longitude": "-76.4621806",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-599-1918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUMW2AN4sIkR87i50Mc-idU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd7cda0a-cf02-4bdd-ac3d-7483142adcd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Hilton Tavern Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "10184 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Casual spot dishing up burgers and beer along with wings, salads and onion rings in a tavern-style setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd920-f9ba-7059-9e97-01047b584532.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-f9ba-7059-9e97-01047b584532",
        "storage_key": "property/6767906449166320/019fd920-f9ba-7059-9e97-01047b584532.webp",
        "width": 540,
        "height": 960
      },
      "poi_business_url": "https://www.hiltontavernbrewingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1226271752850173090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilton-tavern-brewing-co",
      "poi_latitude": "37.0297226",
      "poi_longitude": "-76.4573683",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-873-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bb-745f-97c0-9d6d560eee5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bb-745f-97c0-9d6d560eee5a",
        "storage_key": "property/6767906449166320/019d0266-10bb-745f-97c0-9d6d560eee5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTyV_GgB4sIkRouy6gqmXBBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_97de0560-5fcd-4658-9e57-696ffe28c397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Monty's Penguin",
      "poi_type": "Restaurants",
      "poi_address": "9607 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Friendly, old-school eatery known for ice cream and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-0296-71c7-a096-1dfb8912ed7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-0296-71c7-a096-1dfb8912ed7d",
        "storage_key": "property/6767906449166320/019fd921-0296-71c7-a096-1dfb8912ed7d.webp",
        "width": 1280,
        "height": 818
      },
      "poi_business_url": "https://www.facebook.com/Montys-Penguin-164222336956209/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17587240399661853934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montys-penguin",
      "poi_latitude": "37.0250032",
      "poi_longitude": "-76.45528",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-595-2151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcJGk1WduokR7mw-WfZtEvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5eb23109-55ec-466c-925c-2fcad2f756a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Smoke BBQ Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "10900 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Unfussy joint supplying homestyle, hardwood-smoked BBQ in a casual sit-down setting.",
      "poi_long_description": "Unfussy joint supplying homestyle, hardwood-smoked BBQ in a casual sit-down setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-0282-7406-9855-79a71264f9ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-0282-7406-9855-79a71264f9ab",
        "storage_key": "property/6767906449166320/019fd921-0282-7406-9855-79a71264f9ab.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.smokenn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9271063463743583748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smoke-bbq-restaurant--bar",
      "poi_latitude": "37.0427572",
      "poi_longitude": "-76.4720559",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-595-4320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4HZlBB4sIkRBPaJnhlvqYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_87e67f43-2c1e-438b-9828-03a1a22d9339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Saffron",
      "poi_type": "Restaurants",
      "poi_address": "10417 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Mediterranean & Middle Eastern cooking with tea & yogurt drinks in an old-school dining room.",
      "poi_long_description": "Mediterranean & Middle Eastern cooking with tea & yogurt drinks in an old-school dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-201c-732b-803a-7fbb8ea3b0cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-201c-732b-803a-7fbb8ea3b0cb",
        "storage_key": "property/6767906449166320/019fd921-201c-732b-803a-7fbb8ea3b0cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.saffronnewportnews.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2516360866934453597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saffron",
      "poi_latitude": "37.0338877",
      "poi_longitude": "-76.46324249999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-223-9978",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbbgs6gN4sIkRXXVSUODo6yI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_213dc412-f28d-45c8-8959-5738d388cb1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Anna's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "9708 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Classic pies, pastas & subs whipped up in simple, compact quarters with booth seating.",
      "poi_long_description": "Classic pies, pastas & subs whipped up in simple, compact quarters with booth seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-22dc-72da-9220-4ba1ce2f08a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-22dc-72da-9220-4ba1ce2f08a5",
        "storage_key": "property/6767906449166320/019fd921-22dc-72da-9220-4ba1ce2f08a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://annaspizzahilton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8502427590286105220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "annas-pizza",
      "poi_latitude": "37.0261721",
      "poi_longitude": "-76.45469310000001",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-595-0723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0nAmVWduokRhNp7d9iw_nU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e3e48c59-29bd-48dc-96ba-5d51616e5e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Second Street American Bistro",
      "poi_type": "Restaurants",
      "poi_address": "115 Arthur Way, Newport News, VA 23602, USA",
      "poi_short_description": "Relaxed, upscale eatery for familiar dishes such as lasagne, seafood and salads.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-0ede-749e-864a-52e3b1ce1b24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-0ede-749e-864a-52e3b1ce1b24",
        "storage_key": "property/6767906449166320/019fd921-0ede-749e-864a-52e3b1ce1b24.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "http://www.secondst.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14520374087465353133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "second-street-american-bistro",
      "poi_latitude": "37.1128538",
      "poi_longitude": "-76.47090399999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-234-4448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGch0A7N4sIkRrb8o4Uy7gsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f7802520-caa6-40cd-b33b-8b16b2e129a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Saté: A New American Experience",
      "poi_type": "Restaurants",
      "poi_address": "694 Town Center Dr, Newport News, VA 23606, USA",
      "poi_short_description": "Upscale, modern eatery offering a creative menu of Southern dishes with Asian and French influences, plus cocktails and beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-1271-72ea-a8d9-d78cfd7fdf45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-1271-72ea-a8d9-d78cfd7fdf45",
        "storage_key": "property/6767906449166320/019fd921-1271-72ea-a8d9-d78cfd7fdf45.webp",
        "width": 926,
        "height": 417
      },
      "poi_business_url": "http://sateexperience.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13163059837088298077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sat-a-new-american-experience",
      "poi_latitude": "37.0864511",
      "poi_longitude": "-76.4745204",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-330-2299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzjFk_95sIkRXfTbUi6VrLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_38f6cb9c-e615-462b-bbfd-8e218e1fba72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Schlesinger's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1106 William Styron Square S, Newport News, VA 23606, USA",
      "poi_short_description": "Traditional chophouse fare pairs with a full bar featuring 150+ wines in white-tablecloth environs.",
      "poi_long_description": "Traditional chophouse fare pairs with a full bar featuring 150+ wines in white-tablecloth environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-17cb-720f-a443-b78edf7bc97d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-17cb-720f-a443-b78edf7bc97d",
        "storage_key": "property/6767906449166320/019fd921-17cb-720f-a443-b78edf7bc97d.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "http://www.schlesingerssteaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7761319965695363232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schlesingers-steakhouse",
      "poi_latitude": "37.0835288",
      "poi_longitude": "-76.487211",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-599-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzfgEsfF4sIkRoEhrN2O_tWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cc8fb5dd-e27b-4277-b7b2-046679145e57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Cure Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "706 Town Center Dr #104, Newport News, VA 23606, USA",
      "poi_short_description": "Casual, modern eatery for espresso drinks including cappuccinos, lattes and tea, plus bagels and muffins by a fountain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-2a34-732f-8262-ad2d223b9786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-2a34-732f-8262-ad2d223b9786",
        "storage_key": "property/6767906449166320/019fd921-2a34-732f-8262-ad2d223b9786.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://curecoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14266030718403638217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cure-coffeehouse",
      "poi_latitude": "37.086308",
      "poi_longitude": "-76.47275359999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-586-5005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1099-70be-aa34-c4f902adaf35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1099-70be-aa34-c4f902adaf35",
        "storage_key": "property/6767906449166320/019d0266-1099-70be-aa34-c4f902adaf35.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJE_pstu55sIkRyXNCjVof-8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b483d093-61e9-4804-b8a5-ebab38a1bfaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "340 Oyster Point Rd, Newport News, VA 23602, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-33cf-720c-88fa-c6acb52a4133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-33cf-720c-88fa-c6acb52a4133",
        "storage_key": "property/6767906449166320/019fd921-33cf-720c-88fa-c6acb52a4133.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.bonefishgrill.com/virginia/newport-news/340-oyster-point-road?y_source=1_MTU1MDI3MjMtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=7801208683110973229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "37.1048168",
      "poi_longitude": "-76.50877249999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-269-0002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnybpHyR5sIkRLb-F9_Z1Q2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_af39dc44-d87c-4021-90b4-51f2735308a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "TASTE",
      "poi_type": "Restaurants",
      "poi_address": "702 Mariners Row, Newport News, VA 23606, USA",
      "poi_short_description": "Local cafe & market chain featuring sandwiches & salads, plus gourmet food items, in a casual space.",
      "poi_long_description": "Local cafe & market chain featuring sandwiches & salads, plus gourmet food items, in a casual space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-2b2c-7239-896b-e69a6d1a8a2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-2b2c-7239-896b-e69a6d1a8a2c",
        "storage_key": "property/6767906449166320/019fd921-2b2c-7239-896b-e69a6d1a8a2c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.tasteunlimited.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16548298089900445135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taste",
      "poi_latitude": "37.085771",
      "poi_longitude": "-76.473871",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-596-8651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYWkOBJF4sIkRz43KpW9dp-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e6542fb-d07c-490a-bccd-d9bf08f44fbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Cove Tavern",
      "poi_type": "Restaurants",
      "poi_address": "711 Town Center Dr, Newport News, VA 23606, USA",
      "poi_short_description": "American fare & cocktails served in an airy space with tropical-inspired art & sidewalk seating.",
      "poi_long_description": "American fare & cocktails served in an airy space with tropical-inspired art & sidewalk seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-2fca-71d7-a293-494aa15c35f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-2fca-71d7-a293-494aa15c35f7",
        "storage_key": "property/6767906449166320/019fd921-2fca-71d7-a293-494aa15c35f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://covetavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1586767945311317008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cove-tavern",
      "poi_latitude": "37.0875156",
      "poi_longitude": "-76.4741576",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-596-1830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bc-747d-bb9e-dd1816fd3f05",
        "storage_key": "property/6767906449166320/019d0266-10bc-747d-bb9e-dd1816fd3f05.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzdL3JN4sIkREOxBCQpVBRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2889c006-ac17-430e-ba4d-a5793eb20f4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11214 Jefferson Ave, Newport News, VA 23601, USA",
      "poi_short_description": "Supermarket chain offering a range of products, from groceries to electronics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-426d-754a-b52b-0d686ee9b351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-426d-754a-b52b-0d686ee9b351",
        "storage_key": "property/6767906449166320/019fd921-426d-754a-b52b-0d686ee9b351.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3157-newport-news-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14803781390940109559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "37.0616967",
      "poi_longitude": "-76.46507509999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 757-327-7473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-0fee-739d-a91b-c4bc8d7b1373.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-0fee-739d-a91b-c4bc8d7b1373",
        "storage_key": "property/6767906449166320/019d0266-0fee-739d-a91b-c4bc8d7b1373.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6rxcXB4sIkR9_qFw72Ycc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dca7e933-36fa-4e29-ac75-d1a99808a665",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "11127 Jefferson Ave, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-5240-73cb-8771-832317b40a6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-5240-73cb-8771-832317b40a6a",
        "storage_key": "property/6767906449166320/019fd921-5240-73cb-8771-832317b40a6a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/newport-news-va-pharmacies/11127-jefferson-ave-newport-news-va-23601/storeid=7081?WT.mc_id=LS_GOOGLE_RX_7081",
      "poi_directions_map_url": "https://maps.google.com/?cid=13664157213789134331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.0583534",
      "poi_longitude": "-76.4662876",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-594-1374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1466-732d-a9a6-9a194cdebebc",
        "storage_key": "property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBapHuHF4sIkR-x3-EpfWoL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04bcf179-3fc1-43fb-9ba9-0485aab7e519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 Beech Dr, Newport News, VA 23601, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-3891-757d-b091-d45c7473577a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-3891-757d-b091-d45c7473577a",
        "storage_key": "property/6767906449166320/019fd921-3891-757d-b091-d45c7473577a.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/va/newport-news/18221",
      "poi_directions_map_url": "https://maps.google.com/?cid=2381380348190696713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "37.0437699",
      "poi_longitude": "-76.45138299999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-933-1633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-161e-727d-9653-51845a62f342",
        "storage_key": "property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq6p1sKaCuokRCaUAQc9cDCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_456fe45e-1d11-41f2-b6fb-4b15307017f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6111 Jefferson Ave, Newport News, VA 23605, USA",
      "poi_short_description": "Variety retail catering to a multitude of needs such as food and home goods, plus electronics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-4f07-774b-9d31-b07d3b61f7ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-4f07-774b-9d31-b07d3b61f7ce",
        "storage_key": "property/6767906449166320/019fd921-4f07-774b-9d31-b07d3b61f7ce.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4623-newport-news-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=682268989728841882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "37.0219897",
      "poi_longitude": "-76.4485359",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-637-4205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-161e-727d-9653-51845a62f342",
        "storage_key": "property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF0efClGduokRmmANBgjodwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d1577c39-36a8-41a3-8a54-78cd27a5ceff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Patrick Henry Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "12300 Jefferson Ave, Newport News, VA 23602, USA",
      "poi_short_description": "Retail chain carrying a large selection of athletic footwear, apparel & accessories, plus fan gear.",
      "poi_long_description": "Retail chain carrying a large selection of athletic footwear, apparel & accessories, plus fan gear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-49d1-7069-a099-5513d79404e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-49d1-7069-a099-5513d79404e6",
        "storage_key": "property/6767906449166320/019fd921-49d1-7069-a099-5513d79404e6.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://shoppatrickhenrymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15094170885882555491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patrick-henry-mall",
      "poi_latitude": "37.1124697",
      "poi_longitude": "-76.4950666",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-249-4305",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-161e-727d-9653-51845a62f342",
        "storage_key": "property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5yT1WNF4sIkRY6wSyHJEedE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8a98f02a-4fae-4562-ba59-16254a648321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "The Shoppes at Oyster Point",
      "poi_type": "Shopping & Retail",
      "poi_address": "615 Pilot House Dr, Newport News, VA 23606, USA",
      "poi_short_description": "Shopping center with a variety of stores and eateries, including a salon.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-56cf-72dd-bcb9-e82096d8c158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-56cf-72dd-bcb9-e82096d8c158",
        "storage_key": "property/6767906449166320/019fd921-56cf-72dd-bcb9-e82096d8c158.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15890321880452698508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shoppes-at-oyster-point",
      "poi_latitude": "37.081759",
      "poi_longitude": "-76.47784109999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-161e-727d-9653-51845a62f342",
        "storage_key": "property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ00ps4ox4sIkRjBEAS4_Dhdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0eca3c5e-41be-472b-b926-f1c3301491ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "41 Hiden Blvd, Newport News, VA 23606, USA",
      "poi_short_description": "Friendly grocery chain offering a variety of produce, meat and other items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-60f1-71b4-8705-c032c5b5f2e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-60f1-71b4-8705-c032c5b5f2e6",
        "storage_key": "property/6767906449166320/019fd921-60f1-71b4-8705-c032c5b5f2e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/va/newport-news/41-hiden-blvd?y_source=1_NTA0NjE3NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9998177150756437942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "37.07068599999999",
      "poi_longitude": "-76.49506819999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-595-6821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-0fee-739d-a91b-c4bc8d7b1373.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-0fee-739d-a91b-c4bc8d7b1373",
        "storage_key": "property/6767906449166320/019d0266-0fee-739d-a91b-c4bc8d7b1373.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF34V0z15sIkRtr9DYCWpwIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b6156516-6e17-47ff-9081-2dd00f4be567",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Brentwood Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Jefferson Ave, Newport News, VA 23601, USA",
      "poi_short_description": "Business center with doctors who some visitors describe as friendly, compassionate, and empathetic.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-618f-735d-a7d0-3cfcd7f44f9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-618f-735d-a7d0-3cfcd7f44f9c",
        "storage_key": "property/6767906449166320/019fd921-618f-735d-a7d0-3cfcd7f44f9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7773569760217265634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brentwood-center",
      "poi_latitude": "37.0473323",
      "poi_longitude": "-76.4593377",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJacFsUwp4sIkR4vV3woJE4Ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c0e49206-a1b6-4022-a3de-2cb2334c0dd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Francisco Village Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-66d8-77ac-9f1e-d5f2979523cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-66d8-77ac-9f1e-d5f2979523cb",
        "storage_key": "property/6767906449166320/019fd921-66d8-77ac-9f1e-d5f2979523cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11386922749760907646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "francisco-village-shopping-center",
      "poi_latitude": "37.0400264",
      "poi_longitude": "-76.4578938",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-161e-727d-9653-51845a62f342",
        "storage_key": "property/6767906449166320/019d0266-161e-727d-9653-51845a62f342.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJb5bLdQh4sIkRfilQEOl5Bp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ec098574-c4b2-422a-88d8-2847fe14f6cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "316 Oyster Point Rd, Newport News, VA 23602, USA",
      "poi_short_description": "Neighborhood grocery chain selling meat, produce and dry goods, plus deli fare and a curbside pickup option.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-6c27-7739-93b9-3babe3b7cd82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-6c27-7739-93b9-3babe3b7cd82",
        "storage_key": "property/6767906449166320/019fd921-6c27-7739-93b9-3babe3b7cd82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/va/newport-news/316-oyster-point-rd?y_source=1_NTA0Njc4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12757624905979269211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "37.1037307",
      "poi_longitude": "-76.5098593",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-249-1663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-0fee-739d-a91b-c4bc8d7b1373.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-0fee-739d-a91b-c4bc8d7b1373",
        "storage_key": "property/6767906449166320/019d0266-0fee-739d-a91b-c4bc8d7b1373.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aJt9SZ5sIkRWxCSWkIwDLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1665d3cc-8fd9-41b4-acef-7f18f5a33d98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Warwick High School",
      "poi_type": "Education",
      "poi_address": "51 Copeland Ln, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-6b48-7620-9a17-1ae858ebac68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-6b48-7620-9a17-1ae858ebac68",
        "storage_key": "property/6767906449166320/019fd921-6b48-7620-9a17-1ae858ebac68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://warwick.nn.k12.va.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9644750792519857881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "warwick-high-school",
      "poi_latitude": "37.0525655",
      "poi_longitude": "-76.4758313",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-591-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgcyKLWt4sIkR2TZQ574J2YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d74e0282-32eb-413d-b4d3-b8020551f588",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Hines Middle School",
      "poi_type": "Education",
      "poi_address": "Homer L Hines Middle School, 561 McLawhorne Dr, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-6a47-7368-bc53-236096a74c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-6a47-7368-bc53-236096a74c83",
        "storage_key": "property/6767906449166320/019fd921-6a47-7368-bc53-236096a74c83.webp",
        "width": 960,
        "height": 475
      },
      "poi_business_url": "http://hines.nn.k12.va.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9307389561752071100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hines-middle-school",
      "poi_latitude": "37.0446008",
      "poi_longitude": "-76.46317719999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 757-591-4878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe5LXxg54sIkRvCtpZn59KoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_70b1c8f1-9bbc-4917-9adb-d86a4211570b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Saunders Elementary School",
      "poi_type": "Education",
      "poi_address": "853 Harpersville Rd, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://saunders.nn.k12.va.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2611417842896929551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saunders-elementary-school",
      "poi_latitude": "37.0868197",
      "poi_longitude": "-76.454438",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-591-4781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdxwe0HWCuokRDwP9NbGePSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43fc4b97-409f-49e1-9faf-5ee4e80bd614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Our Lady of Mount Carmel School",
      "poi_type": "Education",
      "poi_address": "52 Harpersville Rd, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-8243-76aa-b07e-8af5a808e04a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-8243-76aa-b07e-8af5a808e04a",
        "storage_key": "property/6767906449166320/019fd921-8243-76aa-b07e-8af5a808e04a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.olmc-school.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11256381257495994029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "our-lady-of-mount-carmel-school",
      "poi_latitude": "37.0524731",
      "poi_longitude": "-76.47246299999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 757-596-2754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjS6CVWt4sIkRrd5pZR2zNpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_977bce36-5921-4a41-9208-925a1f9e03d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Peninsula Catholic High School",
      "poi_type": "Education",
      "poi_address": "600 Harpersville Rd, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-7be8-71be-8a9b-c35668bd99a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-7be8-71be-8a9b-c35668bd99a6",
        "storage_key": "property/6767906449166320/019fd921-7be8-71be-8a9b-c35668bd99a6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.peninsulacatholic.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13359859544560843777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peninsula-catholic-high-school",
      "poi_latitude": "37.0706272",
      "poi_longitude": "-76.45706129999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-596-7247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO-0Z-394sIkRATyp4njBZ7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d2b7efbd-cddc-406a-873e-01621f10bb6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Deer Park Elementary School",
      "poi_type": "Education",
      "poi_address": "11541 Jefferson Ave, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-7f84-71fc-809f-04cbbe956f2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-7f84-71fc-809f-04cbbe956f2e",
        "storage_key": "property/6767906449166320/019fd921-7f84-71fc-809f-04cbbe956f2e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://deerpark.nn.k12.va.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853397176848658154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deer-park-elementary-school",
      "poi_latitude": "37.0726623",
      "poi_longitude": "-76.4753637",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-591-7470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyVfZuGF4sIkR6q4GGCQCxPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01b35184-af0b-4671-8bee-484bffc7d9b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Hilton Elementary School",
      "poi_type": "Education",
      "poi_address": "225 River Rd, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-82af-70f9-bbea-c75b6e26ed05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-82af-70f9-bbea-c75b6e26ed05",
        "storage_key": "property/6767906449166320/019fd921-82af-70f9-bbea-c75b6e26ed05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://hilton.nn.k12.va.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428714643592783094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilton-elementary-school",
      "poi_latitude": "37.0287788",
      "poi_longitude": "-76.464249",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-591-4772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9cnx9Ph3sIkR9iTfSwOG2YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_635f8ea3-e261-41c3-ade0-4696521f63fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Gatewood Peep",
      "poi_type": "Education",
      "poi_address": "1241 Gatewood Rd, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://peep.nn.k12.va.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2725801366453836689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gatewood-peep",
      "poi_latitude": "37.0542276",
      "poi_longitude": "-76.4751062",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-591-4963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM9t6ZGt4sIkRkVvBn-b90yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e7a78fa5-cbe8-47af-a929-be02bd37775b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Watkins Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "21 Burns Dr, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-94a9-75ad-ad70-38572f6bcfab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-94a9-75ad-ad70-38572f6bcfab",
        "storage_key": "property/6767906449166320/019fd921-94a9-75ad-ad70-38572f6bcfab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://watkinsecc.nn.k12.va.us/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6063587740071509722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watkins-early-childhood-center",
      "poi_latitude": "37.0761222",
      "poi_longitude": "-76.4591911",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 757-591-4815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv3bJP1M8LhUR2j5gX-wwJlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_62d66b55-2988-4d02-a445-6e3ed9230301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Christopher Newport University",
      "poi_type": "Education",
      "poi_address": "1 Avenue of the Arts, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-9874-75fb-9d86-56b7734b7719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-9874-75fb-9d86-56b7734b7719",
        "storage_key": "property/6767906449166320/019fd921-9874-75fb-9d86-56b7734b7719.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cnu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11637463082459132917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christopher-newport-university",
      "poi_latitude": "37.0639589",
      "poi_longitude": "-76.4934475",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-594-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD4N-Vk54sIkR9fOy_AOTgKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0b39a421-78fc-4cb3-9ec5-4f84381ca042",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "The Mariners' Museum and Park",
      "poi_type": "Entertainment",
      "poi_address": "100 Museum Dr, Newport News, VA 23606, USA",
      "poi_short_description": "Remains of the ironclad USS Monitor anchor this extensive museum exploring global maritime history.",
      "poi_long_description": "Remains of the ironclad USS Monitor anchor this extensive museum exploring global maritime history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-978e-70ce-ab2e-21a53faf20be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-978e-70ce-ab2e-21a53faf20be",
        "storage_key": "property/6767906449166320/019fd921-978e-70ce-ab2e-21a53faf20be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.marinersmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12817614246955130918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mariners-museum-and-park",
      "poi_latitude": "37.0551904",
      "poi_longitude": "-76.4880841",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-596-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1963-74cf-90b4-1bf7764129a1",
        "storage_key": "property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XYAcUd4sIkRJiC_OT9Q4bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_769fba6c-0800-421d-820a-4cf2ef582a56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Ferguson Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "1 Avenue of the Arts, Newport News, VA 23606, USA",
      "poi_short_description": "Modern concert hall and performing-arts theater hosting Virginia Symphony Orchestra shows.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-97f1-7558-9846-f6842fd234e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-97f1-7558-9846-f6842fd234e2",
        "storage_key": "property/6767906449166320/019fd921-97f1-7558-9846-f6842fd234e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fergusoncenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18174666445710107525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ferguson-center-for-the-arts",
      "poi_latitude": "37.061889",
      "poi_longitude": "-76.49037249999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-594-8752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLS5wCk94sIkRhSPDv9ZiOfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_851a6ebd-f3ee-416c-a3df-c0ef7568717f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Mary M. Torggler Fine Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "1 Avenue of the Arts, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-aa29-70b4-8268-e5480f405223.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-aa29-70b4-8268-e5480f405223",
        "storage_key": "property/6767906449166320/019fd921-aa29-70b4-8268-e5480f405223.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://thetorggler.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=60846440571095095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mary-m-torggler-fine-arts-center",
      "poi_latitude": "37.0631588",
      "poi_longitude": "-76.49151429999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-594-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4A-Rel5sIkRN0gW7IMr2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8da9a725-21ef-4ba9-826c-4c1d915ee623",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Virginia Living Museum",
      "poi_type": "Entertainment",
      "poi_address": "524 J Clyde Morris Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Museum with hands-on exhibits, a planetarium & a nature trail with 250 species of plants & animals.",
      "poi_long_description": "Museum with hands-on exhibits, a planetarium & a nature trail with 250 species of plants & animals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-a285-75fb-ba40-a7a54c2511b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-a285-75fb-ba40-a7a54c2511b3",
        "storage_key": "property/6767906449166320/019fd921-a285-75fb-ba40-a7a54c2511b3.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://www.thevlm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=853408834035564059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-living-museum",
      "poi_latitude": "37.0699771",
      "poi_longitude": "-76.4796305",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-595-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1963-74cf-90b4-1bf7764129a1",
        "storage_key": "property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSgtGV54sIkRG77eINDq1ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e2a55a2-fc11-4e53-81d3-cfd18602794b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Virginia Air & Space Science Center",
      "poi_type": "Entertainment",
      "poi_address": "600 Settlers Landing Rd, Hampton, VA 23669, USA",
      "poi_short_description": "Movie theater chain known for presenting 3D films on a giant screen, including blockbusters.",
      "poi_long_description": "Movie theater chain known for presenting 3D films on a giant screen, including blockbusters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-a409-73a8-9a59-d6999ff79e8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-a409-73a8-9a59-d6999ff79e8c",
        "storage_key": "property/6767906449166320/019fd921-a409-73a8-9a59-d6999ff79e8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.vasc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11952324419825162361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-air--space-science-center",
      "poi_latitude": "37.0240972",
      "poi_longitude": "-76.34410319999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 757-727-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1963-74cf-90b4-1bf7764129a1",
        "storage_key": "property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf4QcHbeEuokRedjn07sv36U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f5d247c4-0339-4051-a464-884545cde8a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Cinemark City Center and XD",
      "poi_type": "Entertainment",
      "poi_address": "11810 Fountain Way Ste J, Newport News, VA 23606, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-a517-74e9-a696-b10175430741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-a517-74e9-a696-b10175430741",
        "storage_key": "property/6767906449166320/019fd921-a517-74e9-a696-b10175430741.webp",
        "width": 1077,
        "height": 1280
      },
      "poi_business_url": "https://www.cinemark.com/theatres/va-newport-news/cinemark-city-center-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxMzItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4241084830517029801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-city-center-and-xd",
      "poi_latitude": "37.085764",
      "poi_longitude": "-76.4721315",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-525-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1be2-75a9-9f81-912ee8542081.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1be2-75a9-9f81-912ee8542081",
        "storage_key": "property/6767906449166320/019d0266-1be2-75a9-9f81-912ee8542081.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwwcpZF4sIkRqetD4S5c2zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_95735b2f-bd35-4c78-82b8-b584118c281e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Regal Kiln Creek",
      "poi_type": "Entertainment",
      "poi_address": "Victory Crossing Shopping Center, 100 Regal Way, Newport News, VA 23602, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-bbe8-7079-8c1e-adfb4b55a333.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-bbe8-7079-8c1e-adfb4b55a333",
        "storage_key": "property/6767906449166320/019fd921-bbe8-7079-8c1e-adfb4b55a333.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-kiln-creek-0161?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11921511807862112739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-kiln-creek",
      "poi_latitude": "37.11037",
      "poi_longitude": "-76.46829",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1be2-75a9-9f81-912ee8542081.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1be2-75a9-9f81-912ee8542081",
        "storage_key": "property/6767906449166320/019d0266-1be2-75a9-9f81-912ee8542081.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJezQnabJ4sIkR4wE_jdO3caU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c36eadb-05c7-4276-87a1-d4e9ef4e4e74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Hilton Tavern Brewing Co.",
      "poi_type": "Entertainment",
      "poi_address": "10184 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Casual spot dishing up burgers and beer along with wings, salads and onion rings in a tavern-style setting.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hiltontavernbrewingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1226271752850173090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilton-tavern-brewing-co",
      "poi_latitude": "37.0297226",
      "poi_longitude": "-76.4573683",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-873-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-10bb-745f-97c0-9d6d560eee5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-10bb-745f-97c0-9d6d560eee5a",
        "storage_key": "property/6767906449166320/019d0266-10bb-745f-97c0-9d6d560eee5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTyV_GgB4sIkRouy6gqmXBBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_96de6389-e45e-4566-8534-cfe31a2c0f1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Peninsula Community Theatre",
      "poi_type": "Entertainment",
      "poi_address": "10251 Warwick Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Community theater (no restaurant) showing musicals and plays in an intimate space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-b594-7006-b22b-bf144e5a0427.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-b594-7006-b22b-bf144e5a0427",
        "storage_key": "property/6767906449166320/019fd921-b594-7006-b22b-bf144e5a0427.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pctlive.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6166756186366304840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peninsula-community-theatre",
      "poi_latitude": "37.0319591",
      "poi_longitude": "-76.46033059999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-595-5728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcynSoAF4sIkRSGLOIBS4lFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_888f5cc5-69bc-4650-b5b1-8f22a0befc1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Surge Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "14346 Warwick Blvd #402, Newport News, VA 23602, USA",
      "poi_short_description": "Activity center with trampoline courts, basketball hoops, a dodgeball court and an arcade.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-b12a-71bb-a4c0-c4f7aa969570.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-b12a-71bb-a4c0-c4f7aa969570",
        "storage_key": "property/6767906449166320/019fd921-b12a-71bb-a4c0-c4f7aa969570.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://surgefun.com/locations/newportnews/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9722935675299881004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "surge-adventure-park",
      "poi_latitude": "37.1284317",
      "poi_longitude": "-76.5330316",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 757-916-4779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhW428NF_sIkRLOA4fHvO7oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_26dcb4cd-827d-48b0-9220-9e05dc382018",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Riverside Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "500 J Clyde Morris Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-b855-76bd-baab-d33fcea09233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-b855-76bd-baab-d33fcea09233",
        "storage_key": "property/6767906449166320/019fd921-b855-76bd-baab-d33fcea09233.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://www.riversideonline.com/locations/hospitals/riverside-regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7633018236414189638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-regional-medical-center",
      "poi_latitude": "37.0633419",
      "poi_longitude": "-76.48343369999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-594-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c91-74bd-888c-8d10dc51bb42",
        "storage_key": "property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzwvNUN4sIkRRuCLAaXt7Wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f9f9721b-e720-4972-bb20-49c19159cd37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Sentara Port Warwick - Emergency Department",
      "poi_type": "Health and Wellness",
      "poi_address": "11803 Jefferson Ave, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-ba6d-73fe-aa05-789f3d402fe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-ba6d-73fe-aa05-789f3d402fe0",
        "storage_key": "property/6767906449166320/019fd921-ba6d-73fe-aa05-789f3d402fe0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sentara.com/hospitalslocations/sentara-port-warwick/medical-services/Sentara-Port-Warwick-Emergency-Department",
      "poi_directions_map_url": "https://maps.google.com/?cid=17831753197733409252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sentara-port-warwick---emergency-department",
      "poi_latitude": "37.084673",
      "poi_longitude": "-76.48461619999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-736-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwMuiO14sIkR5PFVgQ4dd_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b032fdf7-db69-46f4-a0bd-2455ae893328",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "CHKD Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "680 Oyster Point Rd, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-bd13-750c-8a81-d1d40de0f136.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-bd13-750c-8a81-d1d40de0f136",
        "storage_key": "property/6767906449166320/019fd921-bd13-750c-8a81-d1d40de0f136.webp",
        "width": 568,
        "height": 320
      },
      "poi_business_url": "https://www.chkd.org/locations/health-center-and-urgent-care-at-tech-center//?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15149482212128635973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chkd-health-center",
      "poi_latitude": "37.1040114",
      "poi_longitude": "-76.4885508",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-668-4845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c91-74bd-888c-8d10dc51bb42",
        "storage_key": "property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-4FA8V4sIkRRbwGec7FPdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e02d1e0-a603-4238-9772-67c29c0c8c78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Patient First Primary and Urgent Care - Denbigh",
      "poi_type": "Health and Wellness",
      "poi_address": "611 Denbigh Blvd, Newport News, VA 23608, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-c108-703d-b008-0826cbd847b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-c108-703d-b008-0826cbd847b5",
        "storage_key": "property/6767906449166320/019fd921-c108-703d-b008-0826cbd847b5.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.patientfirst.com/locations/tidewater/denbigh?utm_source=local&utm_medium=organic&utm_campaign=gbp&y_source=1_NTI1NTU2MDEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633495848695707876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patient-first-primary-and-urgent-care---denbigh",
      "poi_latitude": "37.1399663",
      "poi_longitude": "-76.5192194",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 757-283-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmTtwI8J-sIkR5DjhDIoxU68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6bd43b14-d3ab-41cf-b18c-3392b818fb8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11127 Jefferson Ave, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-5240-73cb-8771-832317b40a6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-5240-73cb-8771-832317b40a6a",
        "storage_key": "property/6767906449166320/019fd921-5240-73cb-8771-832317b40a6a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/newport-news-va-pharmacies/11127-jefferson-ave-newport-news-va-23601/storeid=7081?WT.mc_id=LS_GOOGLE_RX_7081",
      "poi_directions_map_url": "https://maps.google.com/?cid=13664157213789134331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.0583534",
      "poi_longitude": "-76.4662876",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-594-1374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1466-732d-a9a6-9a194cdebebc",
        "storage_key": "property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBapHuHF4sIkR-x3-EpfWoL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7758fa9f-b965-47bf-a16b-580f497af200",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11214 Jefferson Ave, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-c435-727d-b52d-fefcffa33800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-c435-727d-b52d-fefcffa33800",
        "storage_key": "property/6767906449166320/019fd921-c435-727d-b52d-fefcffa33800.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3157-newport-news-va/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=5446123343979499175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "37.0613671",
      "poi_longitude": "-76.4650376",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 757-327-7478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1466-732d-a9a6-9a194cdebebc",
        "storage_key": "property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQiMbnB4sIkRp07cmFOElEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06e26417-37ac-49c0-8190-bbc81e6b66a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "600 J Clyde Morris Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-c7ac-732a-a38a-174e4581a90d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-c7ac-732a-a38a-174e4581a90d",
        "storage_key": "property/6767906449166320/019fd921-c7ac-732a-a38a-174e4581a90d.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-600+j+clyde+morris+blvd-newport+news-va-23601/id=5175",
      "poi_directions_map_url": "https://maps.google.com/?cid=9454611337679181861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "37.0735772",
      "poi_longitude": "-76.47371919999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 757-599-6264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1466-732d-a9a6-9a194cdebebc",
        "storage_key": "property/6767906449166320/019d0266-1466-732d-a9a6-9a194cdebebc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-91vAop4sIkRJZi_P-uGNYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_494c975e-4214-427f-a5e6-abeceee033ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "301B Oyster Point Rd, Newport News, VA 23602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-c664-7786-9f89-d3fbf49c2635.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-c664-7786-9f89-d3fbf49c2635",
        "storage_key": "property/6767906449166320/019fd921-c664-7786-9f89-d3fbf49c2635.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/newport-news-va?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7851905272306284909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.1055092",
      "poi_longitude": "-76.5112417",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-330-5371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8W7a9SR5sIkRbTnVdT6S92w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1699f6bf-61b3-4714-bc23-aa477f765055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12515 Jefferson Ave, Newport News, VA 23602, USA",
      "poi_short_description": "Heart-rate based full-body cardio and strength training workout studio with friendly trainers and staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-d6cc-76b6-b0f8-70856c67743b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-d6cc-76b6-b0f8-70856c67743b",
        "storage_key": "property/6767906449166320/019fd921-d6cc-76b6-b0f8-70856c67743b.webp",
        "width": 1054,
        "height": 627
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/newport-news-virginia-0764?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=6821193130906879237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "37.1267853",
      "poi_longitude": "-76.5131753",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-849-0220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7HmutF-sIkRBQUKKAO_qV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c74e115-cb32-44f3-9ec6-56fa3cf44a8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "12120 Jefferson Ave STE A, Newport News, VA 23602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-cf52-7014-b59f-c85c542bc5c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-cf52-7014-b59f-c85c542bc5c4",
        "storage_key": "property/6767906449166320/019fd921-cf52-7014-b59f-c85c542bc5c4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/newportnews/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17813748350797622853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "37.1062436",
      "poi_longitude": "-76.4941505",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-657-0687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfVfsldd5sIkRRS5-Z74lN_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da682023-0027-455a-8810-e2fee985e04f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Hilton Fishing Pier",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "225 River Rd, Newport News, VA 23601, USA",
      "poi_short_description": "Pier popular for fishing, featuring a playground, and beautiful sunsets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-db8e-74f6-acf9-330937dd6770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-db8e-74f6-acf9-330937dd6770",
        "storage_key": "property/6767906449166320/019fd921-db8e-74f6-acf9-330937dd6770.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.newport-news.org/visitors/things-to-do/outdoors-and-recreation/31/hilton-pier-and-ravine/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3622478454376521638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilton-fishing-pier",
      "poi_latitude": "37.0284608",
      "poi_longitude": "-76.4653787",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-886-7912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFS_5Zgd4sIkRpl-eJ_agRTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23a3cfa0-1f8e-484a-86fa-aa10923e6dfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Municipal Lane Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10218 Municipal Ln, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-19f2-777f-b345-3decedf90725.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-19f2-777f-b345-3decedf90725",
        "storage_key": "property/6767906449166320/019fd922-19f2-777f-b345-3decedf90725.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.nnparks.com/parks_neighborhood.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=18227801597794527849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "municipal-lane-park",
      "poi_latitude": "37.0323292",
      "poi_longitude": "-76.4583538",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-926-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c8b-768f-8071-05da99c3ea8d",
        "storage_key": "property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1Px8AB4sIkRaSrXaPoo9vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f6027a43-1790-4035-8cca-e0a424d3806d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Virginia Living Museum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "524 J Clyde Morris Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Museum with hands-on exhibits, a planetarium & a nature trail with 250 species of plants & animals.",
      "poi_long_description": "Museum with hands-on exhibits, a planetarium & a nature trail with 250 species of plants & animals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-a285-75fb-ba40-a7a54c2511b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-a285-75fb-ba40-a7a54c2511b3",
        "storage_key": "property/6767906449166320/019fd921-a285-75fb-ba40-a7a54c2511b3.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://www.thevlm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=853408834035564059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-living-museum",
      "poi_latitude": "37.0699771",
      "poi_longitude": "-76.4796305",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-595-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1963-74cf-90b4-1bf7764129a1",
        "storage_key": "property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSgtGV54sIkRG77eINDq1ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_624e38f9-2353-410f-b316-2fc76d846692",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Deer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11523 Jefferson Ave, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-32ce-7185-99f3-a1b5cee58477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-32ce-7185-99f3-a1b5cee58477",
        "storage_key": "property/6767906449166320/019fd922-32ce-7185-99f3-a1b5cee58477.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10828421252371512631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deer-park",
      "poi_latitude": "37.0687853",
      "poi_longitude": "-76.4758289",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c8b-768f-8071-05da99c3ea8d",
        "storage_key": "property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAMGF4sIkRN_3k8cFHRpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc972a06-adbd-4d41-8180-96f7bb7ebe4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Riverview Farm Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 City Farm Rd, Newport News, VA 23602, USA",
      "poi_short_description": "Walking trails & large playground, along with picnic areas, a skate park & a seasonal sledding hill.",
      "poi_long_description": "Walking trails & large playground, along with picnic areas, a skate park & a seasonal sledding hill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-f1ea-7368-9db3-e47e67a3394e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-f1ea-7368-9db3-e47e67a3394e",
        "storage_key": "property/6767906449166320/019fd921-f1ea-7368-9db3-e47e67a3394e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nnparks.com/parks_riverview.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=12719930733782515079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-farm-park",
      "poi_latitude": "37.0841149",
      "poi_longitude": "-76.5329957",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 757-886-7912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c8b-768f-8071-05da99c3ea8d",
        "storage_key": "property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvco8BnJ5sIkRhz2u-ptFhrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9ec96f37-e589-43da-967c-ea9996c49fe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Fido Field",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "125 City Farm Rd, Newport News, VA 23602, USA",
      "poi_short_description": "Shady park for dogs featuring benches, a separate area for smaller pups and a water fountain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-fe9d-72d1-84e6-18bb85d9438e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-fe9d-72d1-84e6-18bb85d9438e",
        "storage_key": "property/6767906449166320/019fd921-fe9d-72d1-84e6-18bb85d9438e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.newport-news.org/visitors/things-to-do/outdoors-and-recreation/33/fido-field-dog-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2212628894816919898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fido-field",
      "poi_latitude": "37.0857514",
      "poi_longitude": "-76.53243739999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-886-7912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c8b-768f-8071-05da99c3ea8d",
        "storage_key": "property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ey41nZ5sIkRWuFTv0HWtB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_240149d7-1b21-476a-a393-1d248798f8e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Newport News Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13560 Jefferson Ave, Newport News, VA 23603, USA",
      "poi_short_description": "Sprawling park on 8,000+ acres with disc golf & bike rentals plus a boat ramp, horses & gardens.",
      "poi_long_description": "Sprawling park on 8,000+ acres with disc golf & bike rentals plus a boat ramp, horses & gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-0500-7291-a849-256fec2a6c44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-0500-7291-a849-256fec2a6c44",
        "storage_key": "property/6767906449166320/019fd922-0500-7291-a849-256fec2a6c44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nnparksandrec.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13292031650869524737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newport-news-park",
      "poi_latitude": "37.1904687",
      "poi_longitude": "-76.5481427",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 757-886-7912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c8b-768f-8071-05da99c3ea8d",
        "storage_key": "property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBa3R7Qx-sIkRAblTvVzIdrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eedceaec-d4a7-4dfd-b0df-0e2a3128a955",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Denbigh Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Newport News, VA 23602, USA",
      "poi_short_description": "Quiet park offering walking trails, a boat ramp & a pier for river fishing, plus sunset views.",
      "poi_long_description": "Quiet park offering walking trails, a boat ramp & a pier for river fishing, plus sunset views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-184a-710f-a9d7-0472ac5daed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-184a-710f-a9d7-0472ac5daed6",
        "storage_key": "property/6767906449166320/019fd922-184a-710f-a9d7-0472ac5daed6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8152870693981236245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denbigh-park",
      "poi_latitude": "37.1225669",
      "poi_longitude": "-76.5654398",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c8b-768f-8071-05da99c3ea8d",
        "storage_key": "property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8SSnPZ7sIkRFaxxTrPQJHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e700f3d2-97a2-4b49-857c-cde69ef5b70e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "King-Lincoln Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Jefferson Ave, Newport News, VA 23607, USA",
      "poi_short_description": "Featuring a beach, this park offers basketball & tennis courts, playgrounds & picnic shelters.",
      "poi_long_description": "Featuring a beach, this park offers basketball & tennis courts, playgrounds & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-1d03-7398-81ea-4a3d21056930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-1d03-7398-81ea-4a3d21056930",
        "storage_key": "property/6767906449166320/019fd922-1d03-7398-81ea-4a3d21056930.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nnparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1125818237763573680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-lincoln-park",
      "poi_latitude": "36.9677251",
      "poi_longitude": "-76.41134439999999",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-888-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c8b-768f-8071-05da99c3ea8d",
        "storage_key": "property/6767906449166320/019d0266-1c8b-768f-8071-05da99c3ea8d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDygkPLOduokRsNeN77i1nw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14316596-3955-4487-af3a-2d38b37a4ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "The Mariners' Museum and Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Museum Dr, Newport News, VA 23606, USA",
      "poi_short_description": "Remains of the ironclad USS Monitor anchor this extensive museum exploring global maritime history.",
      "poi_long_description": "Remains of the ironclad USS Monitor anchor this extensive museum exploring global maritime history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-978e-70ce-ab2e-21a53faf20be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-978e-70ce-ab2e-21a53faf20be",
        "storage_key": "property/6767906449166320/019fd921-978e-70ce-ab2e-21a53faf20be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.marinersmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12817614246955130918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mariners-museum-and-park",
      "poi_latitude": "37.0551904",
      "poi_longitude": "-76.4880841",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-596-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1963-74cf-90b4-1bf7764129a1",
        "storage_key": "property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XYAcUd4sIkRJiC_OT9Q4bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_adeef5d1-0fd7-4efe-8f95-9ed6e320216d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Newport News Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "150 35th St, Newport News, VA 23607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-23e4-7427-a70f-61204b0f9579.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-23e4-7427-a70f-61204b0f9579",
        "storage_key": "property/6767906449166320/019fd922-23e4-7427-a70f-61204b0f9579.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gohrt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10517629123596219748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newport-news-transit-center",
      "poi_latitude": "36.983189",
      "poi_longitude": "-76.43529699999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-222-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMR1UxJ-duokRZHVBj_Yf9pE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bca67a48-8720-42df-a4cb-a4fb84d77389",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Newport News Transportation Center | Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "500B Bland Blvd, Newport News, VA 23602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-322a-72dd-b08e-4a3e58860cc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-322a-72dd-b08e-4a3e58860cc8",
        "storage_key": "property/6767906449166320/019fd922-322a-72dd-b08e-4a3e58860cc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/npn",
      "poi_directions_map_url": "https://maps.google.com/?cid=8493497546838123009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newport-news-transportation-center--amtrak",
      "poi_latitude": "37.1222602",
      "poi_longitude": "-76.5172654",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ383nd1V_sIkRASLwswT33nU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_986d2866-5769-4626-8ca7-7eaa3168065d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Newport News/Williamsburg International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 Bland Blvd, Newport News, VA 23602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-36ea-701c-be91-55540f2d7408.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-36ea-701c-be91-55540f2d7408",
        "storage_key": "property/6767906449166320/019fd922-36ea-701c-be91-55540f2d7408.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.newportnewsairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2339208698118879879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newport-newswilliamsburg-international-airport",
      "poi_latitude": "37.1302795",
      "poi_longitude": "-76.5025939",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-877-0221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1e4f-75e7-9eca-c8178002a6c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e4f-75e7-9eca-c8178002a6c4",
        "storage_key": "property/6767906449166320/019d0266-1e4f-75e7-9eca-c8178002a6c4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJVU2FVCN_sIkRhzrh0uqJdiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd9f66ed-49ea-4844-92f4-db0f78b4a708",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Holiday Inn Express & Suites Newport News by IHG",
      "poi_type": "Transportation & Transit",
      "poi_address": "943 J Clyde Morris Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "Laid-back hotel offering complimentary Wi-Fi, breakfast & an airport shuttle, plus an indoor pool.",
      "poi_long_description": "Laid-back hotel offering complimentary Wi-Fi, breakfast & an airport shuttle, plus an indoor pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-2d15-7655-bcde-2f605b4d9961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-2d15-7655-bcde-2f605b4d9961",
        "storage_key": "property/6767906449166320/019fd922-2d15-7655-bcde-2f605b4d9961.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.ihg.com/holidayinnexpress/hotels/us/en/newport-news/phfnn/hoteldetail?cm_mmc=GoogleMaps-_-EX-_-US-_-PHFNN",
      "poi_directions_map_url": "https://maps.google.com/?cid=11498577409372378784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holiday-inn-express--suites-newport-news-by-ihg",
      "poi_latitude": "37.0928935",
      "poi_longitude": "-76.46034759999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-596-6417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-2071-77ec-8a30-bfedbb11e05b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-2071-77ec-8a30-bfedbb11e05b",
        "storage_key": "property/6767906449166320/019d0266-2071-77ec-8a30-bfedbb11e05b.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ38E206F4sIkRoNb4Uzsnk58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4c03d861-9be1-4950-81e6-c13acaa00b30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Hampton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2 W Pembroke Ave, Hampton, VA 23669, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-3714-7671-ada5-d3ed9ed61971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-3714-7671-ada5-d3ed9ed61971",
        "storage_key": "property/6767906449166320/019fd922-3714-7671-ada5-d3ed9ed61971.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gohrt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590100726815212791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampton-transit-center",
      "poi_latitude": "37.0307315",
      "poi_longitude": "-76.3467234",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-222-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDwYbmEuokR90R5UP4GlE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7a1f11f9-e13c-4fdd-82eb-11741a7f6cee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Huntington Ingalls Industries",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4101 Washington Ave, Newport News, VA 23607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8592567824509288894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huntington-ingalls-industries",
      "poi_latitude": "36.98809010000001",
      "poi_longitude": "-76.43720739999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-380-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb4EHtgyduokRvsFTOOnuPnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9f8691ef-3940-4e56-ad15-5e6e38d0dbbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Thomas Jefferson National Accelerator Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12000 Jefferson Ave, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-3bb3-729e-9b05-fd2eafa770ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-3bb3-729e-9b05-fd2eafa770ce",
        "storage_key": "property/6767906449166320/019fd922-3bb3-729e-9b05-fd2eafa770ce.webp",
        "width": 947,
        "height": 533
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8217680665069675022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-jefferson-national-accelerator-facility",
      "poi_latitude": "37.0966346",
      "poi_longitude": "-76.48673769999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-269-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVplkup4sIkRDuISlwYRC3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_46c6777f-d585-4939-97ab-f994fc432739",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Christopher Newport University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Avenue of the Arts, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-9874-75fb-9d86-56b7734b7719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-9874-75fb-9d86-56b7734b7719",
        "storage_key": "property/6767906449166320/019fd921-9874-75fb-9d86-56b7734b7719.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cnu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11637463082459132917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christopher-newport-university",
      "poi_latitude": "37.0639589",
      "poi_longitude": "-76.4934475",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-594-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-165c-73af-97fc-172ee9cb3b41",
        "storage_key": "property/6767906449166320/019d0266-165c-73af-97fc-172ee9cb3b41.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD4N-Vk54sIkR9fOy_AOTgKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20887022-c17c-4760-9ee2-48fbcf8ed9e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Canon Virginia Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12000 Canon Blvd, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-447e-744b-a276-ea9eda7b5e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-447e-744b-a276-ea9eda7b5e00",
        "storage_key": "property/6767906449166320/019fd922-447e-744b-a276-ea9eda7b5e00.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cvi.canon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13747349878738715523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canon-virginia-inc",
      "poi_latitude": "37.1023119",
      "poi_longitude": "-76.4725758",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-881-6020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1656-7753-8c51-d8d3aa8f1b1d",
        "storage_key": "property/6767906449166320/019d0266-1656-7753-8c51-d8d3aa8f1b1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqlp5sIkRgwM7zeBlyL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_68d58218-df2c-4339-b9fc-32826d1b54b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Riverside Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 J Clyde Morris Blvd, Newport News, VA 23601, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-b855-76bd-baab-d33fcea09233.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-b855-76bd-baab-d33fcea09233",
        "storage_key": "property/6767906449166320/019fd921-b855-76bd-baab-d33fcea09233.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://www.riversideonline.com/locations/hospitals/riverside-regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=7633018236414189638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-regional-medical-center",
      "poi_latitude": "37.0633419",
      "poi_longitude": "-76.48343369999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-594-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c91-74bd-888c-8d10dc51bb42",
        "storage_key": "property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzwvNUN4sIkRRuCLAaXt7Wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c53c1087-baad-4fc5-bc3f-9654899ca2e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Sentara Port Warwick",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11803 Jefferson Ave, Newport News, VA 23606, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-43a9-741a-a014-ea25a6b5df27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-43a9-741a-a014-ea25a6b5df27",
        "storage_key": "property/6767906449166320/019fd922-43a9-741a-a014-ea25a6b5df27.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sentara.com/hospitalslocations/sentara-port-warwick/map-and-directions",
      "poi_directions_map_url": "https://maps.google.com/?cid=16090062437589462132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sentara-port-warwick",
      "poi_latitude": "37.0851895",
      "poi_longitude": "-76.4824723",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-736-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1c91-74bd-888c-8d10dc51bb42",
        "storage_key": "property/6767906449166320/019d0266-1c91-74bd-888c-8d10dc51bb42.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq-LJ8vF4sIkRdCxgxoliS98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a789434a-9c08-493f-bec7-cbad9df60c92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Newport News",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Washington Ave, Newport News, VA 23607, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-5737-750b-a327-150198ca1724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-5737-750b-a327-150198ca1724",
        "storage_key": "property/6767906449166320/019fd922-5737-750b-a327-150198ca1724.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nnva.gov/Blog.aspx?IID=853",
      "poi_directions_map_url": "https://maps.google.com/?cid=8639633803366957793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newport-news",
      "poi_latitude": "36.9774093",
      "poi_longitude": "-76.43012999999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-933-2311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-21d7-7150-9b0b-393facf28184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21d7-7150-9b0b-393facf28184",
        "storage_key": "property/6767906449166320/019d0266-21d7-7150-9b0b-393facf28184.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNdT7tKOduokR4QIlXysl5nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_88ca8ffd-3edc-41a3-8285-da1a1b52d7e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Langley Air Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "210 Sweeney Blvd, Hampton, VA 23665, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-4484-7054-857e-36911cbbec0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-4484-7054-857e-36911cbbec0d",
        "storage_key": "property/6767906449166320/019fd922-4484-7054-857e-36911cbbec0d.webp",
        "width": 1062,
        "height": 708
      },
      "poi_business_url": "http://www.jble.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14206231051187135798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "langley-air-force-base",
      "poi_latitude": "37.08350739999999",
      "poi_longitude": "-76.35922409999999",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-764-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-21d7-7150-9b0b-393facf28184.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21d7-7150-9b0b-393facf28184",
        "storage_key": "property/6767906449166320/019d0266-21d7-7150-9b0b-393facf28184.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn15x4wmEuokRNiUii9-rJsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_855ed3c2-5ff0-467d-aa66-a4aaad8bd67d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "Newport News/Williamsburg International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "900 Bland Blvd, Newport News, VA 23602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-36ea-701c-be91-55540f2d7408.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd922-36ea-701c-be91-55540f2d7408",
        "storage_key": "property/6767906449166320/019fd922-36ea-701c-be91-55540f2d7408.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.newportnewsairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2339208698118879879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newport-newswilliamsburg-international-airport",
      "poi_latitude": "37.1302795",
      "poi_longitude": "-76.5025939",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-877-0221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1e4f-75e7-9eca-c8178002a6c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e4f-75e7-9eca-c8178002a6c4",
        "storage_key": "property/6767906449166320/019d0266-1e4f-75e7-9eca-c8178002a6c4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJVU2FVCN_sIkRhzrh0uqJdiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23b87ca1-fa7d-444d-be79-cae836e54b11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "poi_name": "The Mariners' Museum and Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Museum Dr, Newport News, VA 23606, USA",
      "poi_short_description": "Remains of the ironclad USS Monitor anchor this extensive museum exploring global maritime history.",
      "poi_long_description": "Remains of the ironclad USS Monitor anchor this extensive museum exploring global maritime history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-978e-70ce-ab2e-21a53faf20be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd921-978e-70ce-ab2e-21a53faf20be",
        "storage_key": "property/6767906449166320/019fd921-978e-70ce-ab2e-21a53faf20be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.marinersmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12817614246955130918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mariners-museum-and-park",
      "poi_latitude": "37.0551904",
      "poi_longitude": "-76.4880841",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-596-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1963-74cf-90b4-1bf7764129a1",
        "storage_key": "property/6767906449166320/019d0266-1963-74cf-90b4-1bf7764129a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0XYAcUd4sIkRJiC_OT9Q4bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9192be97b5ff793c260ec907",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c8f47445b865d37c6351f4bb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_9032477ed9094aad2ef82583",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_493cf839761792aca21a8156",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_62d20c366f97c453726c0bb0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_73bd2551f27fe36ef5a5313d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_6d8f359ab19e537f8df7b98b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "rating": "4",
      "name": "David Mook",
      "text": "My experience here has been superb to say the least, phenomenal even in comparison to where I moved from. The staff here helped and guided me step by step from applying, lease signing to move in day. Caleb Justice one of the leasing agents made this whole ordeal second to none. He was prompt very professional and made good on everything he promised. I can’t speak for any other leasing agents but he definitely made a great impression on their behalf",
      "date": "2025-10-29",
      "title": "false"
    },
    {
      "id": "ec_32c7830561e1a84ab65d9dca",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "rating": "5",
      "name": "asiah felton",
      "text": "I love Caleb so much!! And I can tell he really loves his job!! He was so helpful throughout this entire process. Answered every email no matter what time it was and he always had such an amazing attitude I never felt like he was bothered to help!! He helped make this process’s so quick, I moved in 4-5days after viewing the property! Everyone in that office was so friendly and welcoming. I really appreciated this. Not to mention the apartment is so beautiful and I look forward to spending my time here. Thank you guys so much!",
      "date": "2025-09-15",
      "title": "false"
    },
    {
      "id": "ec_d7f2e904a88fea6f9de04f7c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "rating": "5",
      "name": "Aniyah Koger",
      "text": "Caleb is absolutely amazing! He’s full of personality, super kind, and had me laughing through the whole process. As a first-time renter with lots of anxiety, I was nervous, but he made everything so much easier than I expected. He answered all my questions thoroughly and went above and beyond in making sure I felt comfortable every step of the way. Caleb truly walked me through the entire process and made it feel stress-free. I’m so excited to move in and call Harborstone my new home!",
      "date": "2025-09-18",
      "title": "false"
    },
    {
      "id": "ec_6c0085e0bbb3f172adb50f6d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "rating": "5",
      "name": "TAMMY JACKSON",
      "text": "Valerie is my baby and she is the best! Caleb is new but is already growing on me and Kellie is the boss. They all give the best customer service! I've live here for over 5yrs and I'm never moving!",
      "date": "2025-09-26",
      "title": "false"
    },
    {
      "id": "ec_5c61f78700fb6b48f1b56377",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "rating": "5",
      "name": "D'Andre Hollis",
      "text": "When I say I love Caleb, I do. He took time with me on a late Thursday evening due to after another complex did not fall through. He supported me through the entire process. I appreciate his professionalism, communication skills, and knowledge that he continually demonstrates through my time working with him. He is the only reason I give this complex a 5 star rating. Caleb is the best leasing agent I have ever encountered!",
      "date": "2025-08-30",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e9e111be-53b9-4777-b0a1-0a697cccd6fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd920-d022-7765-a6a1-af5a70f0b99f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd920-d022-7765-a6a1-af5a70f0b99f",
        "storage_key": "property/6767906449166320/019fd920-d022-7765-a6a1-af5a70f0b99f.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "360 Tours",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6a3c8449b28a48c66d968de5"
    },
    {
      "id": "custom_bc8fcf63-8fb3-4eef-a4ba-8140f52481ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd920-cf44-76bf-baac-fffcd7aa3109.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd920-cf44-76bf-baac-fffcd7aa3109",
        "storage_key": "property/6767906449166320/019fd920-cf44-76bf-baac-fffcd7aa3109.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR - Premium Platinum",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=c3ik1umDTQp"
    },
    {
      "id": "custom_6c480cc7-06d2-44c7-8e32-3ec4aba03396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd920-d44b-72c7-b913-367e03397799.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd920-d44b-72c7-b913-367e03397799",
        "storage_key": "property/6767906449166320/019fd920-d44b-72c7-b913-367e03397799.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR - Premium Platinum",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vRxjgsbGYv5"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_606c284f46c3ad1d96c7f576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "396297",
      "name": "Pet Rent",
      "description": "false",
      "amount": 55,
      "amount_max": 0,
      "amount_raw": "55.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0e7db44cb644acd46c00da0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "396308",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "350.00 / 150.00",
      "amount_type": "text",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_39da672855fc20c89a86bae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "396309",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eec009fbf93ba58653258511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "396310",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8288411310616aa5c273452f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "396312",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5a75b6082f6d986fed0819f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "396313",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fffe1ceaccb1505951c99b7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "396316",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_2eaddefe13d3febdd782fcac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "536723",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3cad7418027347714a97e709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "543041",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_35366227c55893b01436b989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "543044",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_aa1cbc62c5c8ded74e9bb7b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "543048",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5c144d74c90c7f7b97262134",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "832493",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9e3759595531ac599df8d871",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "832494",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_370916b3ec13d946f724bca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "832495",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cca4aa8cedbb9ec02081c181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "engrain",
      "external_id": "832497",
      "name": "Washer/Dryer Fee",
      "description": "false",
      "amount": 60,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2815-d90a-73bc-8b7a-42e42a0a4e81",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-harborstone-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320"
    },
    {
      "lead_collector_id": "019c3043-53ec-7547-a206-b2a0eb770094",
      "lead_source": "FACEBOOK_ADS",
      "name": "harborstone",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320"
    },
    {
      "lead_collector_id": "019c3043-545b-776e-bf71-714d05bdab72",
      "lead_source": "LANDING_PAGE",
      "name": "harborstone",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "dog-park-apartments-newport-news-va-harborstone-222",
      "search_query": "dog park apartments newport news va",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Newport News, VA",
      "h2_subtitle": "Discover dog-friendly living at Harborstone. Our Newport News apartments feature a dedicated dog park for your four-legged family members.",
      "page_copy": "Welcome to Harborstone, the place where dogs are part of our vibrant community. Located in Newport News, VA, our apartments offer a modern way of living that caters to pet owners. Enjoy our on-site dog park where your furry friends can roam and play freely. Our gated community ensures a safe environment, making it a perfect choice for pet lovers.\n\nBeyond the dog park, Harborstone provides residents with access to amenities that cater to all lifestyles. From a fully equipped fitness center to a relaxing resident lounge, you will find everything you need. Whether you choose a cozy studio or a spacious three-bedroom, each apartment is designed with your comfort in mind. Make the move to a pet-friendly home that suits both you and your pets at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Newport News, VA",
      "seo_description": "Looking for dog park apartments in Newport News, VA? Discover Harborstone—pet-friendly living with all the amenities you love.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-south-newport-news-harborstone-651",
      "search_query": "pet friendly apartments south newport news",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in South Newport News",
      "h2_subtitle": "Experience pet-friendly living in South Newport News. Harborstone welcomes you and your pets with open arms and accommodating amenities.",
      "page_copy": "At Harborstone, we believe that pets are family, which is why we offer pet friendly apartments in the heart of South Newport News. Our vibrant community is designed with both functionality and comfort in mind, ensuring an ideal living situation for pet owners. Your pets will love the dedicated dog park, providing them a safe space to play and socialize.\n\nIn addition to accommodating our furry friends, Harborstone boasts a variety of amenities for their human counterparts. Residents can enjoy a modern fitness center, a cozy resident lounge, and a picnic area perfect for spending leisurely afternoons. Whether you're opting for a studio or a three-bedroom apartment, you'll find spacious floor plans and a warm community atmosphere waiting for you here. Embrace the comfort and convenience of pet-friendly living at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in South Newport News",
      "seo_description": "Harborstone offers pet-friendly apartments in South Newport News, featuring amenities like a dog park, resident lounge, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-23601-harborstone-366",
      "search_query": "fitness center apartments 23601",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 23601",
      "h2_subtitle": "Explore Harborstone's apartments with a fitness center in the 23601 area. Our Newport News location offers convenience and community amenities.",
      "page_copy": "Harborstone in Newport News, situated in the 23601 area, invites you to elevate your lifestyle with our fitness center apartments. Our state-of-the-art fitness center is fully equipped, offering everything you need to maintain an active and healthy lifestyle right at your doorstep. Whether you're a fitness enthusiast or just starting out, you'll find the perfect setup here.\n\nLocated in South Newport News, Harborstone not only caters to fitness needs but also provides a wide range of amenities to enhance your living experience. From the controlled access building ensuring a secure environment to the inviting resident lounge where you can unwind, each detail of our community is designed for your comfort. Choose from a variety of floor plans, including cozy studios and expansive three-bedroom apartments. Experience the perfect balance of active and comfortable living at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 23601",
      "seo_description": "Discover Harborstone's apartments with a fitness center in the 23601 area, complete with great amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-newport-news-city-harborstone-444",
      "search_query": "air conditioned apartments newport news city",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Newport News City",
      "h2_subtitle": "Stay cool in Newport News City with air-conditioned apartments at Harborstone. Enjoy comfort and convenience in our vibrant community.",
      "page_copy": "Harborstone offers air conditioned apartments within the heart of Newport News City, ensuring your comfort during the warmest Virginia days. Our spacious floor plans, ranging from cozy studios to generous three-bedroom units, are designed with your convenience in mind. With central air conditioning, each apartment provides a cool and inviting retreat.\n\nBeyond the comfort of air conditioning, Harborstone enhances your living experience with an array of community amenities. Take advantage of our resident lounge for relaxation, get active in the fully equipped fitness center, or enjoy outdoor gatherings at the picnic area. Located in the lively neighborhood of South Newport News, Harborstone is perfectly positioned for both convenience and community, offering easy access to everything you need. Experience modern living with all the comforts at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Newport News City",
      "seo_description": "Find cool comfort at Harborstone's air-conditioned apartments in Newport News City, featuring excellent amenities for a modern lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-with-resident-lounge-va-23601-harborstone-157",
      "search_query": "apartments with resident lounge va 23601",
      "category": "Amenity",
      "h1_title": "Apartments with Resident Lounge in VA 23601",
      "h2_subtitle": "Discover Harborstone's apartments featuring a resident lounge in VA 23601. Enjoy a community-centric living experience in Newport News.",
      "page_copy": "Welcome to Harborstone, where you'll find comfortable apartments with a resident lounge in the vibrant area of VA 23601. Our community in Newport News is designed to foster connection and relaxation with spaces that cater to your lifestyle. The resident lounge is a perfect spot for socializing, working, or simply unwinding after a long day.\n\nIn addition to our welcoming lounge, Harborstone offers numerous amenities that enhance your everyday living experience. Stay active in our fully-equipped fitness center, enjoy outdoor meals at our picnic area, or let your pets roam in the safe dog park. Each apartment, whether a studio or a three-bedroom, is crafted with care and attention to detail, ensuring a comfortable living space for all. Experience the warmth of community living and modern conveniences at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Resident Lounge in VA 23601",
      "seo_description": "Find community-focused living at Harborstone's apartments with a resident lounge in VA 23601, featuring modern amenities in Newport News.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "studio-apartments-in-newport-news-harborstone-805",
      "search_query": "studio apartments in Newport News",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Newport News",
      "h2_subtitle": "Discover cozy studio apartments at Harborstone in Newport News. Perfectly designed for modern living in a welcoming community.",
      "page_copy": "Harborstone presents stylish studio apartments in the heart of Newport News, offering an idyllic blend of comfort and convenience. Ideal for individuals seeking a compact yet functional living space, our studios are thoughtfully designed to maximize every square foot without sacrificing style.\n\nLocated in the lively South Newport News neighborhood, Harborstone provides access to a variety of amenities designed to enhance your lifestyle. Enjoy the fitness center, relax in the resident lounge, or meet friends at the picnic area. With controlled access buildings and linoleum flooring, you can enjoy modern conveniences in a vibrant community setting. Experience a seamless blend of efficiency and comfort in our studio apartments at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Newport News",
      "seo_description": "Explore Harborstone's cozy studio apartments in Newport News, offering modern amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-near-south-newport-news-harborstone-885",
      "search_query": "one bedroom apartments near South Newport News",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near South Newport News",
      "h2_subtitle": "Experience comfortable living in one bedroom apartments near South Newport News. Discover the ideal blend of style and convenience at Harborstone.",
      "page_copy": "Discover the comfort of one bedroom apartments near South Newport News at Harborstone. Each unit is designed with spacious layouts and modern finishes, perfect for those looking to enjoy a peaceful, yet centrally-located community. Our one bedroom apartments offer the ideal balance of comfort and functionality for singles or couples.\n\nAt Harborstone, you not only enjoy a well-appointed apartment, but also a suite of amenities to enhance your lifestyle. Engage in a workout at our fully-equipped fitness center, relax in the resident lounge, or enjoy the outdoors at our picnic area. Our convenient location in Newport News places you close to shopping, dining, and entertainment options, all while being nestled in a welcoming community. Come home to Harborstone's one bedroom apartments and enjoy a lifestyle designed just for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near South Newport News",
      "seo_description": "Find ideal living at Harborstone's one bedroom apartments near South Newport News, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-newport-news-va-harborstone-74",
      "search_query": "two bedroom apartments Newport News VA",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Newport News, VA",
      "h2_subtitle": "Explore spacious two bedroom apartments at Harborstone in Newport News, VA. Ideal for families or roommates seeking comfort and style.",
      "page_copy": "Welcome to Harborstone, where our two bedroom apartments in Newport News, VA, offer a perfect blend of space and elegance. These thoughtfully designed units provide ample room for both families and roommates, ensuring comfort and convenience in every corner. Enjoy modern touches in a community that values both functionality and style.\n\nOur extensive amenities further elevate your living experience. Work out in our state-of-the-art fitness center, gather with friends in the resident lounge, or unwind outdoors in the picnic area. Located in the vibrant South Newport News neighborhood, Harborstone offers not just a home, but a complete lifestyle package. Make the most of Newport News living with a two bedroom apartment designed to meet all your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Newport News, VA",
      "seo_description": "Discover spacious two bedroom apartments in Newport News, VA at Harborstone, featuring modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-newport-news-city-harborstone-419",
      "search_query": "three bedroom apartments Newport News City",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Newport News City",
      "h2_subtitle": "Find roomy three bedroom apartments at Harborstone in Newport News City. Perfect for bigger families or those needing extra space.",
      "page_copy": "Harborstone offers expansive three bedroom apartments in Newport News City, perfectly suited for families or those who desire additional living space. These well-appointed units provide spacious interiors with all the conveniences of modern living, ensuring you have plenty of room to grow.\n\nLocated in the dynamic neighborhood of South Newport News, Harborstone surrounds you with top-tier amenities such as a state-of-the-art fitness center, a welcoming resident lounge, and a tranquil picnic area. With controlled access buildings and thoughtful layouts, you'll find both privacy and community connectivity here. Discover the perfect blend of space and comfort in our three bedroom apartments at Harborstone, your gateway to a vibrant Newport News lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Newport News City",
      "seo_description": "Explore spacious three bedroom apartments in Newport News City at Harborstone, offering modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-warwick-high-school-newport-news-harborstone-388",
      "search_query": "apartments near Warwick High School Newport News",
      "category": "School",
      "h1_title": "Apartments Near Warwick High School, Newport News",
      "h2_subtitle": "Discover convenient apartments near Warwick High School in Newport News. Harborstone offers ideal living spaces close to educational opportunities.",
      "page_copy": "Located just minutes from Warwick High School, Harborstone provides apartments that are perfect for families and students looking for proximity to top educational facilities in Newport News. Our spacious floor plans range from studios to three-bedroom units, each designed to offer comfort and style in a welcoming community.\n\nLiving at Harborstone means enjoying a host of top-notch amenities. Take advantage of our fitness center, unwind in the resident lounge, or enjoy a meal at our picnic area. Nestled in South Newport News, our apartments not only offer a great living environment but are also strategically positioned near shopping, dining, and recreational destinations. Experience the ideal blend of location and lifestyle at Harborstone’s apartments near Warwick High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Warwick High School, Newport News",
      "seo_description": "Find convenient apartments near Warwick High School at Harborstone in Newport News with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-close-to-hines-middle-school-va-harborstone-966",
      "search_query": "apartments close to Hines Middle School VA",
      "category": "School",
      "h1_title": "Apartments Close to Hines Middle School, VA",
      "h2_subtitle": "Discover apartments conveniently close to Hines Middle School in Newport News, VA. Harborstone offers family-friendly living.",
      "page_copy": "Harborstone presents an ideal choice for families seeking apartments close to Hines Middle School in Newport News, VA. Our diverse selection of layouts, from cozy studios to expansive three bedrooms, ensures a perfect fit for every lifestyle. These thoughtfully designed spaces offer convenience and comfort in a community-focused environment.\n\nEnjoy easy access to excellent educational facilities, complemented by Harborstone’s extensive amenities, including a modern fitness center, a relaxing resident lounge, and a serene picnic area. Located in South Newport News, our community supports both active living and quality time at home. Discover the benefits of a supportive community paired with a prime location near Hines Middle School at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Hines Middle School, VA",
      "seo_description": "Explore family-friendly apartments near Hines Middle School at Harborstone, Newport News, VA, with welcoming spaces and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-saunders-elementary-school-23601-harborstone-413",
      "search_query": "apartments near Saunders Elementary School 23601",
      "category": "School",
      "h1_title": "Apartments Near Saunders Elementary School 23601",
      "h2_subtitle": "Find family-friendly apartments near Saunders Elementary School, nestled in the vibrant community of Newport News, VA 23601.",
      "page_copy": "At Harborstone, discover the perfect home with our apartments near Saunders Elementary School in the 23601 area of Newport News. Our range of floor plans from studios to three bedrooms provide ample space and modern amenities designed with family life in mind.\n\nPositioned in South Newport News, our community offers more than just a place to live. Enjoy access to a fully-equipped fitness center, a comfortable resident lounge, and inviting picnic areas perfect for family gatherings. With convenient proximity to Saunders Elementary School, Harborstone ensures that quality education is just a stone's throw away, making it an excellent choice for families seeking a supportive and engaging environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saunders Elementary School 23601",
      "seo_description": "Discover Harborstone's family-friendly apartments near Saunders Elementary School in the bustling 23601 area of Newport News, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-our-lady-of-mount-carmel-school-newport-news-city-harborstone-338",
      "search_query": "apartments near Our Lady of Mount Carmel School Newport News City",
      "category": "School",
      "h1_title": "Apartments Near Our Lady of Mount Carmel School",
      "h2_subtitle": "Explore quality living in Newport News City with apartments near Our Lady of Mount Carmel School. Harborstone is your gateway to convenience and comfort.",
      "page_copy": "Harborstone offers the perfect residential solution for those seeking apartments near Our Lady of Mount Carmel School in Newport News City. With a variety of floor plans available, from efficient studios to expansive three-bedroom options, we cater to diverse needs and offer excellent access to educational opportunities.\n\nSituated in South Newport News, our community is characterized by its welcoming environment and exceptional amenities. Residents can enjoy a state-of-the-art fitness center, a cozy resident lounge, and a scenic picnic area, all designed to enhance your living experience. With close proximity to Our Lady of Mount Carmel School, Harborstone provides families with the ideal combination of convenience and community, making every day a pleasant journey.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Our Lady of Mount Carmel School",
      "seo_description": "Find ideal living spaces near Our Lady of Mount Carmel School at Harborstone in Newport News City with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-close-to-peninsula-catholic-high-school-south-newport-news-harborstone-710",
      "search_query": "apartments close to Peninsula Catholic High School South Newport News",
      "category": "School",
      "h1_title": "Apartments Close to Peninsula Catholic High School",
      "h2_subtitle": "Find accommodating apartments close to Peninsula Catholic High School in South Newport News. Experience the convenience of Harborstone today.",
      "page_copy": "Harborstone is your go-to destination for apartments close to Peninsula Catholic High School in South Newport News. Our community offers a range of apartment layouts, from studios to three-bedroom homes, ideal for students and families alike. Each unit is designed to provide comfort and functionality, making it easy to focus on studies and leisure.\n\nLocated in the vibrant area of South Newport News, residents enjoy the benefits of a secure community with a variety of amenities including a modern fitness center and resident lounge. Our convenient location near Peninsula Catholic High School means less time commuting and more time enjoying the comforts of home. Harborstone is where convenience meets an enriching community experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Peninsula Catholic High School",
      "seo_description": "Discover Harborstone's welcoming apartments near Peninsula Catholic High School in South Newport News with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-deer-park-elementary-school-newport-news-harborstone-807",
      "search_query": "apartments near Deer Park Elementary School Newport News",
      "category": "School",
      "h1_title": "Apartments Near Deer Park Elementary School",
      "h2_subtitle": "Discover ideal living with apartments near Deer Park Elementary School in Newport News. Harborstone offers comfort and convenience for families.",
      "page_copy": "Nestled in Newport News, Harborstone provides an excellent choice for families seeking apartments near Deer Park Elementary School. From cozy studios to spacious three-bedroom units, our apartments cater to various needs while offering a welcoming community atmosphere.\n\nLocated conveniently in South Newport News, residents of Harborstone enjoy amenities that include a secure building, a well-equipped fitness center, and a friendly dog park. With Deer Park Elementary School nearby, living here simplifies daily routines, making school commutes quick and easy while offering a vibrant lifestyle and the comforts of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Deer Park Elementary School",
      "seo_description": "Find perfect family apartments at Harborstone near Deer Park Elementary School in Newport News, with easy access and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-close-to-hilton-elementary-school-va-harborstone-313",
      "search_query": "apartments close to Hilton Elementary School VA",
      "category": "School",
      "h1_title": "Apartments Close to Hilton Elementary School VA",
      "h2_subtitle": "Explore convenient living with apartments close to Hilton Elementary School in VA. Harborstone makes family living easy and comfortable.",
      "page_copy": "Harborstone offers a fantastic choice for families searching for apartments close to Hilton Elementary School, VA. Our vibrant community features a range of floor plans from studios to three-bedroom layouts, catering to all family sizes with a homely and accommodating design.\n\nSituated perfectly in South Newport News, Harborstone residents benefit from a wealth of amenities, such as a modern fitness center, a resident lounge, and an inviting picnic area. Proximity to Hilton Elementary School ensures that daily commutes are short and stress-free, allowing families to enjoy more quality time together while experiencing the best of both convenience and community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Hilton Elementary School VA",
      "seo_description": "Discover family-friendly apartments at Harborstone near Hilton Elementary School, VA, offering a comfortable lifestyle and easy commutes.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-gatewood-peep-in-newport-news-harborstone-252",
      "search_query": "apartments near Gatewood Peep in Newport News",
      "category": "School",
      "h1_title": "Apartments Near Gatewood Peep in Newport News",
      "h2_subtitle": "Discover ideal living with apartments near Gatewood Peep in Newport News. Harborstone offers comfort and convenience.",
      "page_copy": "If you're searching for apartments near Gatewood Peep in Newport News, Harborstone is your perfect match. Our community offers a diverse range of apartment options from cozy studios to sizable three-bedroom homes, tailored for diverse lifestyles and families.\n\nSituated in vibrant South Newport News, our residents enjoy convenient amenities like a top-tier fitness center and a welcoming resident lounge. Living near Gatewood Peep ensures that entertainment and everyday necessities are within easy reach, making Harborstone an excellent choice for those who value both community and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gatewood Peep in Newport News",
      "seo_description": "Explore Harborstone's comfortable living near Gatewood Peep in Newport News with excellent amenities and convenience at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-christopher-newport-university-newport-news-harborstone-100",
      "search_query": "apartments near Christopher Newport University Newport News",
      "category": "School",
      "h1_title": "Apartments Near Christopher Newport University",
      "h2_subtitle": "Find convenient apartments near Christopher Newport University in Newport News at Harborstone. Perfect for students and families alike.",
      "page_copy": "At Harborstone, we offer an ideal living experience for students and families seeking apartments near Christopher Newport University in Newport News. Choose from a variety of floor plans, including studios and expansive three-bedroom apartments, designed to cater to diverse living situations.\n\nLocated in the dynamic South Newport News area, Harborstone residents enjoy amenities such as a modern fitness center, controlled access buildings, and a friendly dog park. Our proximity to Christopher Newport University makes attending classes and campus events a breeze, providing you with both convenience and comfort in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Christopher Newport University",
      "seo_description": "Discover Harborstone's convenient living near Christopher Newport University with spacious apartments and top-notch amenities in Newport News.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-riverside-regional-medical-center-newport-news-va-harborstone-433",
      "search_query": "apartments near Riverside Regional Medical Center Newport News VA",
      "category": "Hospital",
      "h1_title": "Apartments Near Riverside Regional Medical Center",
      "h2_subtitle": "Find comfortable apartments near Riverside Regional Medical Center in Newport News, VA. Harborstone offers convenience for healthcare professionals.",
      "page_copy": "Harborstone presents a perfect residential choice for healthcare professionals and families seeking apartments near Riverside Regional Medical Center in Newport News, VA. Our community features a variety of living spaces, from intimate studios to spacious three-bedroom apartments, accommodating diverse lifestyle needs.\n\nNestled in South Newport News, Harborstone provides residents with excellent amenities, including a well-equipped fitness center, a welcoming resident lounge, and a delightful picnic area. The proximity to Riverside Regional Medical Center ensures that work commutes are seamless, allowing you more time to relax and enjoy the vibrant community around you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riverside Regional Medical Center",
      "seo_description": "Discover Harborstone near Riverside Regional Medical Center, Newport News, VA. Enjoy spacious living and amenities perfect for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-by-chkd-health-center-south-newport-news-harborstone-352",
      "search_query": "apartments by CHKD Health Center South Newport News",
      "category": "Hospital",
      "h1_title": "Apartments by CHKD Health Center South",
      "h2_subtitle": "Explore apartments by CHKD Health Center in South Newport News. Harborstone offers a blend of comfort and convenience.",
      "page_copy": "Discover ideal living at Harborstone, where you can find apartments by CHKD Health Center in South Newport News. Our community offers a range of floor plans from studios to three-bedroom apartments, all designed to suit varying needs.\n\nLocated in the lively South Newport News area, Harborstone provides residents with unrivaled amenities such as a fitness center, a resident lounge, and a dog park. Being close to CHKD Health Center ensures an easy commute, making Harborstone a perfect choice for those wishing to balance professional commitments with personal comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by CHKD Health Center South Newport News",
      "seo_description": "Discover Harborstone's ideal living by CHKD Health Center in South Newport News. Enjoy spacious apartments and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-municipal-lane-park-newport-news-harborstone-855",
      "search_query": "apartments near Municipal Lane Park Newport News",
      "category": "Park",
      "h1_title": "Apartments Near Municipal Lane Park",
      "h2_subtitle": "Discover apartments near Municipal Lane Park in Newport News at Harborstone, offering serene living with top-notch amenities.",
      "page_copy": "Located in the vibrant community of South Newport News, Harborstone offers ideal apartments near Municipal Lane Park. With a selection of cozy studios to spacious three-bedroom layouts, we provide the perfect living spaces that cater to various lifestyles and preferences.\n\nHarborstone residents enjoy access to superb amenities, such as a fitness center, a welcoming resident lounge, and a controlled access building. The park's proximity means residents can easily enjoy outdoor activities and relaxation. Experience the perfect blend of convenience and community living by making Harborstone your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Municipal Lane Park",
      "seo_description": "Find comfortable living at Harborstone, near Municipal Lane Park in Newport News. Enjoy spacious apartments and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "harborstone-near-deer-park-va-apartments-139",
      "search_query": "Harborstone near Deer Park VA",
      "category": "Park",
      "h1_title": "Harborstone Apartments Near Deer Park",
      "h2_subtitle": "Experience Harborstone near Deer Park, VA, where comfort meets convenience. Enjoy our spacious apartments and welcoming community.",
      "page_copy": "Nestled in the heart of South Newport News, Harborstone boasts a prime location near Deer Park, VA, offering residents a seamless blend of suburban tranquility and urban convenience. Our diverse range of floor plans includes everything from intimate studios to expansive three-bedroom apartments, catering to a wide array of living needs.\n\nAt Harborstone, indulge in our exceptional community amenities, including a modern fitness center, a welcoming resident lounge, and a scenic picnic area. The close proximity to Deer Park provides opportunities for outdoor recreation right at your doorstep, making it the perfect spot for relaxation and leisure. Choose Harborstone for a harmonious balance of serenity and lifestyle convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Harborstone Apartments Near Deer Park",
      "seo_description": "Discover Harborstone near Deer Park, VA, with spacious apartments and top-notch amenities for a comfortable living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "riverview-farm-park-proximity-apartments-harborstone-873",
      "search_query": "Riverview Farm Park proximity apartments",
      "category": "Park",
      "h1_title": "Apartments Near Riverview Farm Park",
      "h2_subtitle": "Find tranquility with apartments near Riverview Farm Park. Experience the welcoming community at Harborstone in Newport News.",
      "page_copy": "At Harborstone, enjoy the serenity of Riverview Farm Park proximity apartments located in the vibrant area of South Newport News. Our community features a selection of diverse floor plans, from chic studios to spacious three-bedroom residences, designed to fit various living situations.\n\nResidents at Harborstone benefit from outstanding amenities, such as a controlled access building, an inviting resident lounge, and a fully-equipped fitness center. Being near Riverview Farm Park means you're moments away from beautiful open spaces and outdoor activities, enhancing your living experience with tranquility and convenience. Choose Harborstone for comfortable apartment living intertwined with natural beauty and local attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riverview Farm Park",
      "seo_description": "Explore Harborstone apartments near Riverview Farm Park. Enjoy convenient living with spacious layouts and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "fido-field-nearby-apartments-harborstone-64",
      "search_query": "Fido Field nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Fido Field Dog Park",
      "h2_subtitle": "Discover apartments near Fido Field at Harborstone, Newport News, where pet-friendly living enhances your lifestyle.",
      "page_copy": "Harborstone in Newport News offers the perfect choice for those seeking apartments near Fido Field Dog Park. Located in the lively South Newport News area, our community provides a welcoming haven for pet lovers with diverse floor plans ranging from cozy studios to spacious three-bedroom apartments.\n\nEnjoy our pet-friendly environment and excellent amenities, including a dog park, a modern fitness center, and a relaxing resident lounge. With Fido Field just a stone's throw away, your four-legged companions can revel in outdoor activities while you relish the convenience and comfort of Harborstone’s vibrant community. Find the ideal balance of pet-friendly and modern living here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Fido Field Park",
      "seo_description": "Live at Harborstone near Fido Field in Newport News. Enjoy pet-friendly apartments with top-notch amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "newport-news-park-local-apartments-harborstone-697",
      "search_query": "Newport News Park local apartments",
      "category": "Park",
      "h1_title": "Local Apartments Near Newport News Park",
      "h2_subtitle": "Explore local apartments near Newport News Park at Harborstone. Enjoy a vibrant community in a prime location.",
      "page_copy": "Located in the heart of South Newport News, Harborstone offers local apartments with easy access to the scenic Newport News Park. Our community is designed to cater to a variety of lifestyles with floor plans that range from intimate studios to spacious three-bedroom homes.\n\nHarborstone residents appreciate excellent amenities like a well-equipped fitness center, a relaxing resident lounge, and controlled access buildings. Living near Newport News Park means endless recreational opportunities and serene natural beauty are just minutes away, ensuring a lifestyle that embraces both excitement and relaxation. Choose Harborstone for its exceptional location and community offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Local Apartments Near Newport News Park",
      "seo_description": "Discover Harborstone's local apartments near Newport News Park. Enjoy a vibrant community with spacious living options and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "denbigh-park-close-housing-harborstone-15",
      "search_query": "Denbigh Park close housing",
      "category": "Park",
      "h1_title": "Close Housing Near Denbigh Park",
      "h2_subtitle": "Find comfortable living close to Denbigh Park at Harborstone. Enjoy a welcoming community with top-tier amenities.",
      "page_copy": "Harborstone offers a variety of housing options for those seeking proximity to Denbigh Park in Newport News. Situated in the dynamic neighborhood of South Newport News, our community provides an array of choices, from cozy studios to ample three-bedroom apartments.\n\nResidents enjoy a wealth of amenities designed for a modern lifestyle, including a state-of-the-art fitness center, a comfortable resident lounge, and the convenience of controlled access buildings. Our location near Denbigh Park allows easy access to outdoor fun and community gatherings, making Harborstone a perfect choice for those who appreciate nature and convenience. Experience delightful living here with us.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Close to Denbigh Park in Newport News",
      "seo_description": "Explore Harborstone's housing options close to Denbigh Park. Enjoy modern amenities and a prime location in Newport News.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "king-lincoln-park-adjacent-apartments-harborstone-883",
      "search_query": "King-Lincoln Park adjacent apartments",
      "category": "Park",
      "h1_title": "Apartments Adjacent to King-Lincoln Park",
      "h2_subtitle": "Discover adjacent apartments near King-Lincoln Park at Harborstone. Experience ideal living in Newport News.",
      "page_copy": "For those desiring a home adjacent to King-Lincoln Park, Harborstone in Newport News offers an inviting community with various living options. Nestled in South Newport News, our apartments range from efficiently planned studios to spacious three-bedroom layouts.\n\nResidents at Harborstone enjoy exceptional amenities, such as a fully-equipped fitness center, an inviting resident lounge, and the benefit of controlled access buildings. Positioned close to King-Lincoln Park, our community provides an ideal base for enjoying outdoor activities and park events. Step into a vibrant lifestyle where location meets comfort at Harborstone.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Adjacent Apartments at King-Lincoln Park",
      "seo_description": "Live at Harborstone, adjacent to King-Lincoln Park. Enjoy proximity to nature and modern amenities in Newport News.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166320",
      "source": "custom",
      "page_item_url": "apartments-near-newport-news-airport-harborstone-369",
      "search_query": "apartments near Newport News Williamsburg International Airport",
      "category": "Transit",
      "h1_title": "Apartments Near Newport News Airport",
      "h2_subtitle": "Discover convenient apartments near Newport News Williamsburg International Airport at Harborstone.",
      "page_copy": "Located in the bustling area of South Newport News, Harborstone offers apartments conveniently near the Newport News Williamsburg International Airport. This prime location is perfect for frequent fliers or those employed at or near the airport, providing easy access and reducing commute times.\n\nOur community balances comfort and convenience with a range of floor plans from studios to three-bedroom apartments. Harborstone amenities include a fully-equipped fitness center, a relaxing resident lounge, and secure controlled access buildings. Enjoy the perfect blend of serene living and connectivity at Harborstone, where airport proximity is just one of the many perks of our vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
      "featured_image_media": {
        "alt_text": "Brick apartment building exterior with a balcony and sliding glass doors.",
        "public_id": "01a015d9-fd48-76f9-b2e3-fcab8059a331",
        "storage_key": "property/6767906449166320/01a015d9-fd48-76f9-b2e3-fcab8059a331.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Newport News Airport",
      "seo_description": "Find ideal living at Harborstone, near Newport News Williamsburg Airport, with great amenities and various apartment options.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5057"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976246964"
    },
    {
      "ID": "custom_fee_guide",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973280"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T7C5X489"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveharborstone.fatwin.com/api/websites/resources/1?x=dXF6T01ycnIrZVJPUTZCUFhqeTZtcHB2TjB0My9PV01Td2JQM2hmODZZb29tWG94eU4xS1pIcjZFZmtkeFBmY1NJcFMzOFhaeTI1OFN6RzB1ZHR0R0E9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywym900wq0"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9549f646-43e6-11ef-860f-6fbf6ff48bb4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549f646-43e6-11ef-860f-6fbf6ff48bb4/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549f646-43e6-11ef-860f-6fbf6ff48bb4/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ims3SGNLVmdaWklFWnA4cGwwYmYxMnc9PSIsInZhbHVlIjoiY01iRTRYYjV2aEIvL0hMOFNFN2xLZz09IiwibWFjIjoiNGY5NDI4NjI3YjlkMGQ3YjFlZWI1ODkyNDU2MzA3NzkxODRhMzAyZmYyMThmMTczMmVlMjhkMzNhN2RjZDc4YiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5057",
  "custom_repli_id": "9976246964",
  "custom_fee_guide": "true",
  "custom_realpage_id": "4973280",
  "custom_google_gtm_id": "GTM-T7C5X489",
  "custom_perq_script_url": "https://liveharborstone.fatwin.com/api/websites/resources/1?x=dXF6T01ycnIrZVJPUTZCUFhqeTZtcHB2TjB0My9PV01Td2JQM2hmODZZb29tWG94eU4xS1pIcjZFZmtkeFBmY1NJcFMzOFhaeTI1OFN6RzB1ZHR0R0E9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/1ywym900wq0",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9549f646-43e6-11ef-860f-6fbf6ff48bb4",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549f646-43e6-11ef-860f-6fbf6ff48bb4/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549f646-43e6-11ef-860f-6fbf6ff48bb4/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ims3SGNLVmdaWklFWnA4cGwwYmYxMnc9PSIsInZhbHVlIjoiY01iRTRYYjV2aEIvL0hMOFNFN2xLZz09IiwibWFjIjoiNGY5NDI4NjI3YjlkMGQ3YjFlZWI1ODkyNDU2MzA3NzkxODRhMzAyZmYyMThmMTczMmVlMjhkMzNhN2RjZDc4YiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "5ea2a52c-bd54-44eb-b03e-a021cafca580",
  "custom_audioeye_site_hash": "0abd7c43197867796d1958d1097b1e7c"
};

export const generatedAt = '2026-10-28T20:49:33.210Z';
